/// <reference path="../_references.js" />

function offenderScheduleConfiguration_Init(aEnrolleeId) {
    "use strict";
    var lSchedules = mEnrolleesData.OffenderSchedules,
        lBuilder = new SumoPredicateBuilder(),
        lConfiguration = new ScheduleConfiguration(),
        lItems,
        lItem,
        lKey;

    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lSchedules = query(lSchedules, lBuilder.RootExpression);
    lBuilder.Clear();

    for (lKey in lSchedules) {
        if (lSchedules.hasOwnProperty(lKey)) {
            lItem = lSchedules[lKey];
            switch (lItem.ScheduleType) {
                case 1:
                    lConfiguration.Zones.push(lItem);
                    break;
                case 2:
                    lConfiguration.BluHomes.push(lItem);
                    break;
                case 3:
                    lConfiguration.BluBoxes.push(lItem);
                    break;
                case 6:
                    lConfiguration.Addresses.push(lItem);
                    break;
            }
        }
    }

    lConfiguration.HasZone = (lConfiguration.Zones.length > 0);
    lConfiguration.HasBluHome = (lConfiguration.BluHomes.length > 0);
    lConfiguration.HasBluBox = (lConfiguration.BluBoxes.length > 0);
    lConfiguration.HasAddress = (lConfiguration.Addresses.length > 0);

    mEnrolleesData.OffenderScheduleConfiguration = lConfiguration;
}

function offenderScheduleConfiguration_Check(aStationType, aDeviceId) {
    "use strict";
    var lErrorMessage = '',
        lIsInError = false,
        lResult = []; 

    function addressError() {
        lErrorMessage += '<li>Address</li>';
        lIsInError = true;
        lResult.push(6);
    }

    function bluBoxError() {
        lErrorMessage += '<li>BLUbox</li>';
        lIsInError = true;
        lResult.push(3);
    }

    function bluHomeError() {
        lErrorMessage += '<li>BLUhome</li>';
        lIsInError = true;
        lResult.push(2);
    }

    function zoneError() {
        lErrorMessage += '<li>Zone</li>';
        lIsInError = true;
        lResult.push(1);
    }

    if (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId <= 2) {
        if (mEnrolleesData.OffenderScheduleConfiguration.HasAddress || mEnrolleesData.OffenderScheduleConfiguration.HasBluHome || mEnrolleesData.OffenderScheduleConfiguration.HasZone) {
            if (mEnrolleesData.OffenderScheduleConfiguration.HasAddress) {
                addressError();
            }
            if (mEnrolleesData.OffenderScheduleConfiguration.HasBluHome) {
                bluHomeError();
            }
            if (mEnrolleesData.OffenderScheduleConfiguration.HasZone) {
                zoneError();
            }
        }
    } else if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 103 || mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 151) {
        if (mEnrolleesData.OffenderScheduleConfiguration.HasAddress) {
            if (mEnrolleesData.OffenderScheduleConfiguration.HasAddress) {
                addressError();
            }
        }

        if ([105, 999].indexOf(aStationType) !== -1 && aDeviceId !== -1 && mEnrolleesData.OffenderScheduleConfiguration.HasBluHome) {
            // bbg
            bluHomeError();
        } else if ([104, 109].indexOf(aStationType) !== -1 && aDeviceId !== -1 && mEnrolleesData.OffenderScheduleConfiguration.HasBluBox) {
            // bluhome
            bluBoxError();
        } else if (aDeviceId === -1) {
            if (mEnrolleesData.OffenderScheduleConfiguration.HasBluHome) {
                bluHomeError();
            }
            if (mEnrolleesData.OffenderScheduleConfiguration.HasBluBox) {
                bluBoxError();
            }
        }
    } else if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 106) {
        if (mEnrolleesData.OffenderScheduleConfiguration.HasAddress || mEnrolleesData.OffenderScheduleConfiguration.HasBluBox || mEnrolleesData.OffenderScheduleConfiguration.HasZone) {
            if (mEnrolleesData.OffenderScheduleConfiguration.HasAddress) {
                addressError();
            }
            if (mEnrolleesData.OffenderScheduleConfiguration.HasBluBox) {
                bluBoxError();
            }
            if (mEnrolleesData.OffenderScheduleConfiguration.HasZone) {
                zoneError();
            }
            if (aDeviceId === -1 && mEnrolleesData.OffenderScheduleConfiguration.HasBluHome) {
                bluHomeError();
            }
        }
    } else if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 110) {
        if (mEnrolleesData.OffenderScheduleConfiguration.HasBluHome || mEnrolleesData.OffenderScheduleConfiguration.HasZone) {
            if (mEnrolleesData.OffenderScheduleConfiguration.HasBluHome) {
                bluHomeError();
            }
            if (mEnrolleesData.OffenderScheduleConfiguration.HasZone) {
                zoneError();
            }
        }
    }
    if (mEnrolleesData.OffenderScheduleConfiguration.HasBluBox && aDeviceId !== -1) {
        bluBoxError();
    }
    if (lIsInError) {
        $('#uDeviceAssignmentsWizardScheduleAlert').show();
        $('#uDeviceAssignmentsWizardScheduleAlertReasons').html(lErrorMessage);
    } else {
        $('#uDeviceAssignmentsWizardScheduleAlert').hide();
    }
    return lResult;
}

function getTrackingProductIds() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lProducts = getDataItems('Products'),
        lProductIds = [],
        lItem,
        lKey;

    lBuilder.AddNewExpressionConditional('IsATrackingUnitOffender', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsATrackingUnitVictim', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lProducts = query(lProducts, lBuilder.RootExpression);

    for (lKey in lProducts) {
        if (lProducts.hasOwnProperty(lKey)) {
            lItem = lProducts[lKey];
            lProductIds.push(lItem.Id);
        }
    }
    return lProductIds;
}

function getAssignableStatusIds() {
    "use strict";
    return [1, 2, 3, 5];
}

// tracking devices
function uDeviceAssignmentsWizardTrackingDeviceCardView_OnRender(aSender) {
    "use strict";
    var lSelectedIndex = mEnrolleesData.OffenderEnrollment.TrackingDeviceId,
        lBuilder = new SumoPredicateBuilder(),
        lProductIds,
        lDeviceAssignments = gCurrentDeviceAssignment[mEnrolleesData.OffenderEnrollment.Id],
        lDevice,
        lItem,
        lKey;

    if (lSelectedIndex === -1) {
        lProductIds = getTrackingProductIds();

        for (lKey in lDeviceAssignments) {
            if (lSelectedIndex === -1 && lDeviceAssignments.hasOwnProperty(lKey)) {
                lItem = lDeviceAssignments[lKey];
                lDevice = getDataItem(lItem.Id, 'Devices');
                if (lProductIds.indexOf(lDevice.ProductId) !== -1) {
                    lSelectedIndex = lDevice.Id;
                }
            }
        }
    }
    if (lSelectedIndex !== -1) {
        aSender.selected(lSelectedIndex);
    }
}

function offenderUnassignedTrackingDevices(aIdentifier, aSearchString) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lMyAssignments = gCurrentDeviceAssignment[mEnrolleesData.OffenderEnrollment.Id],
        lTrackingProductIds = getTrackingProductIds(),
        lDevices = getDataItems('Devices'),
        lProducts = getDataItems('Products'),
        lEnrollee = getDataItem(mEnrolleesData.OffenderEnrollment.Id, 'Enrollees'),
        lSort = new SortExpression(),
        lLastContact,
        lDevice,
        lResult = [],
        lItem,
        lKey;
        const SOBERTRACK_MAX_TEST_THRESHOLD = veritracks.system.clientSetting('SobertrackUsageTestLimit') ?? 1800;//#No. Tests
        const SOBERTRACK_MAX_DAYS_IN_FIELD_THRESHOLD = veritracks.system.clientSetting('SobertrackDaysInFieldLimit') ?? 180;// In Days
        


    lBuilder.AddNewExpressionConditional('Status', getAssignableStatusIds(), false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('OrganizationId', lEnrollee.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    if (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId <= 2) {
        lBuilder.AddNewExpressionConditional('ProductId', [103, 151], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    } else {
        lBuilder.AddNewExpressionConditional('ProductId', lTrackingProductIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    }
    if (!isNullOrUndefined(aIdentifier) && !isNullOrUndefined(aSearchString)) {
        lBuilder.AddNewExpressionConditional(aIdentifier, aSearchString, false, mRelationalOperatorEnum.Like(), mLogicalOperatorEnum.And());
    }
    lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lDevices = query(getDataItems('Devices'), lBuilder.RootExpression);

    for (lKey in lMyAssignments) {
        if (lMyAssignments.hasOwnProperty(lKey)) {
            lItem = lMyAssignments[lKey];
            lDevice = getDataItem(lItem.Id, 'Devices');
            if (!isNullOrUndefined(lDevice) && lTrackingProductIds.indexOf(lDevice.ProductId) !== -1) {
                lDevices[lDevice.Id] = lDevice;
            }
        }
    }
    
    for (lKey in lDevices) {
        if (lDevices.hasOwnProperty(lKey)) {
            lDevice = $.extend({}, lDevices[lKey]);
            lDevice.ProductName = lProducts[lDevice.ProductId].Name;
            var DEVICE_MAX_THRESHOLD_CALL =  lDevice.STTotalTests > SOBERTRACK_MAX_TEST_THRESHOLD | lDevice.DaysInSchema >  SOBERTRACK_MAX_DAYS_IN_FIELD_THRESHOLD;
            if(DEVICE_MAX_THRESHOLD_CALL && lDevice.ProductName == 'SoberTrack'){
                continue;
            }
            
            lLastContact = gDeviceLastContact[lDevice.Id];
            if (!isNullOrUndefined(lLastContact)) {
                lDevice.TrackingDeviceContactDateDisplay = DisplayShortDateTime(lLastContact.ContactDate);
                lDevice.LastContactBatteryLevel = DisplayVolts(lLastContact.BatteryVoltage);
                lDevice.LastContactBatteryImage = inventoryBatteryLevelFormatter(lLastContact.BatteryLevel);
                lDevice.LastContactBatteryPercentage = deviceBatteryPercentageFormatter(lLastContact.BatteryPercentage);
                lDevice.PercentGps = DisplayPercent(lLastContact.PercentGps);
                lDevice.ContactStatus = contactStatusImageFormatter(lLastContact.Status);
                lDevice.LastContactDisplay = 'block';
            } else {
                lDevice.ContactStatus = '';
                lDevice.LastContactDisplay = 'none';
            }
            if (lDevice.HasDevicePairingSupport) {
                lDevice.BluTwoCapableUnit = 'block';
            } else {
                lDevice.BluTwoCapableUnit = 'none';
            }
            if (lDevice[aIdentifier].indexOf(aSearchString) !== -1) {
                lResult[lDevice.Id] = lDevice;
            }
        }
    }
    lSort.addAscendingColumn('SerialNumber');
    lResult = lSort.sort(lResult);
    console.log(aSearchString,lResult)
    return lResult;
}

function uDeviceAssignmentsWizardTrackingDeviceCardView_OnSelectChange(aSender, aSelectedIndex, aParams) {
    "use strict";

    var lSelectedDevice = mEnrolleesControls.TrackingDeviceCardView.selectedDataItem(),
        lBLUPlusUnPairedAssignment = veritracks.system.clientSetting('BluPlusUnpairedEnable'),
        lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression(),
        lPointList = [],
        lLabelList = [],
        lContact;

    if (isNullOrUndefined(lBLUPlusUnPairedAssignment)) {
        lBLUPlusUnPairedAssignment = false;
    }

    $('.sumo-wizard-blade-2').show();
    $('.sumo-wizard-blade-3').show();


    //if (mEnrolleesData.AddOnsAvailable) {
    //    if (lSelectedDevice && (lSelectedDevice.HasDevicePairingSupport || lSelectedDevice.ProductId == 103)) {
    //        mEnrolleesControls.DeviceAssignmentsWizard.FixPagesOnSelect(true, 3);
    //        mEnrolleesControls.DeviceAssignmentsWizard.FixPageDisplay();
    //    } else {
    //        mEnrolleesControls.DeviceAssignmentsWizard.FixPagesOnSelect(true, 3);
    //        mEnrolleesControls.DeviceAssignmentsWizard.FixPageDisplay();
    //    }
    //}
    //else {
    //    mEnrolleesControls.DeviceAssignmentsWizard.FixPageDisplay();
    //}


    function onRead(aParams, aData) {
        "use strict";
        FixDates(aData);
        $('#uDeviceAssignmentsWizardListViewHolder').show();
        $('#uDeviceAssignmentsWizardListViewWaiting').hide();
        mEnrolleesControls.DeviceAssignmentsContactList.setDataSource(aData);
    }

    if (!isNullOrUndefined(aSelectedIndex)) {
        $('#uDeviceAssignmentsWizardListViewHolder').hide();
        $('#uDeviceAssignmentsWizardListViewWaiting').show();
        lBuilder.AddNewExpressionConditional('DeviceId', lSelectedDevice.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lSort.addDescendingColumn('TrackDate');
        mEnrolleesControls.DeviceAssignmentsContactList.setDataSource([]);
        GetDeviceContact(lSelectedDevice.Id, new Date(0).toWcf(), onRead, null);
        //ReadMultiple(gObjectList.DeviceContact.AssemblyQualifiedName, lBuilder.RootExpression, 0, onRead, null, null, lSort, 20);

        
    } else {
        onRead(null, []);
    }

    if (!isNullOrUndefined(lSelectedDevice) && (lSelectedDevice.ProductId === 103 || lSelectedDevice.ProductId === 151)) {
        $('#uDeviceAssignmentsWizardMapTab').show();
        lContact = gDeviceLastContact[lSelectedDevice.Id];
        if (!isNullOrUndefined(lContact) && (lContact.Latitude !== 0 || lContact.Longitude !== 0)) {
            //lPointList.push({
            //    'data': lContact,
            //    'latitude': lContact.Latitude,
            //    'longitude': lContact.Longitude,
            //    'anchor': { 'x': 6, 'y': 6 },
            //    'iconUri': 'Images/Maps/Trackpoints/1100000.png',
            //    'hoverText': DisplayShortDateTime(lContact.TrackDate)
            //});
            lPointList.push(veritracks.mapping.prepareTrackpointMarkerItem({ 'TrackTypeId': 8, 'Latitude': lContact.Latitude, 'Longitude': lContact.Longitude, 'TrackDate': lContact.TrackDate }, 1));
            lLabelList.push({
                'data': lContact,
                'latitude': lContact.Latitude,
                'longitude': lContact.Longitude,
                'text': lSelectedDevice.SerialNumber,
                'horizontalOffset': -15,
                'verticalOffset': -15,
                'cssClass': 'NumericLabel'
            });
        }
    } else {
        $('#uDeviceAssignmentsWizardMapTab').hide();
        uDeviceAssignmentsWizardTab_OnClick('Contact');
    }
    mEnrolleesControls.DeviceAssignmentsMap.layerSetDataSource('Contact', lPointList);
    mEnrolleesControls.DeviceAssignmentsMap.layerSetDataSource('Labels', lLabelList);
    mEnrolleesControls.DeviceAssignmentsMap.fitBounds();
    $('#uDeviceAssignmentsWizardSoberTrackDetails').hide();
    $('#uDeviceAssignmentsWizardSoberTrackDetails').html('');
    if (isNullOrUndefined(lSelectedDevice)) {
        $('.sumo-wizard-blade-command .sumo-wizard-save').hide();
        $('.sumo-wizard-blade-command .sumo-wizard-next').hide();
        
    } else {
        if (lSelectedDevice.ProductId === 110 && lBLUPlusUnPairedAssignment) {
            $('.sumo-wizard-blade-command .sumo-wizard-save').show();
            $('.sumo-wizard-blade-command .sumo-wizard-next').hide();
        }
        else if (lSelectedDevice.ProductId === 110 || (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId <= 2)) {
            $('.sumo-wizard-blade-command .sumo-wizard-save').hide();
            $('.sumo-wizard-blade-command .sumo-wizard-next').show();
        } else if (lSelectedDevice.ProductId === 121) {
            $('.sumo-wizard-blade-command .sumo-wizard-save').show();
            $('.sumo-wizard-blade-command .sumo-wizard-next').hide();
            $('.sumo-wizard-blade-2').hide();
            $('.sumo-wizard-blade-3').hide();
            $('#uDeviceAssignmentsWizardSoberTrackDetails').show();
            $('#uDeviceAssignmentsWizardSoberTrackDetails').html(`
                <p>This Device has ${lSelectedDevice.STTotalTests} ${localizeWrapper('cEnrolleeTotalNumberOfTests')} and ${lSelectedDevice.DaysInSchema} ${localizeWrapper('cEnrolleeDaysInSchema')}</p>
            `);
        } else {
            $('.sumo-wizard-blade-command .sumo-wizard-save').show();
            $('.sumo-wizard-blade-command .sumo-wizard-next').show();
        }
    }
}

function uDeviceAssignmentsWizardTrackingSearch_OnChange() {
    "use strict";
    if (!isNullOrUndefined(mEnrolleesControls.TrackingDeviceCardView)) {
        var lValue = $('#uDeviceAssignmentsWizardTrackingSearch').val(),
            lList = offenderUnassignedTrackingDevices('SerialNumber', lValue);
        mEnrolleesControls.TrackingDeviceCardView.setDataSource(lList);
        if (lList.length === 0) {
            $('.sumo-wizard-blade-command .sumo-wizard-save').hide();
            $('.sumo-wizard-blade-command .sumo-wizard-next').hide();
        } else {
            $('.sumo-wizard-blade-command .sumo-wizard-save').show();
            $('.sumo-wizard-blade-command .sumo-wizard-next').show();
        }
    }
}

function uDeviceAssignmentsWizardAddOnDeviceCardView_OnRender() {
    "use strict";
    var lAssignments,
        lKey,
        lItem,
        lDevice,
        lSelected = null;

    if (mEnrolleesData.OffenderEnrollment.AddOnDeviceType === 111) {
        if (mEnrolleesData.OffenderEnrollment.AddOnDeviceId !== -1) {
            lSelected = 'A' + mEnrolleesData.OffenderEnrollment.AddOnDeviceId.toString();
        }
    }

    mEnrolleesControls.AddOnCardView.selected(lSelected);
}

// station devices
function uDeviceAssignmentsWizardStationDeviceCardView_OnRender() {
    "use strict";
    var lAssignments,
        lKey,
        lItem,
        lDevice,
        lSelected = null;
    if (mEnrolleesData.OffenderEnrollment.StationDeviceType === 999) {
        if (mEnrolleesData.OffenderEnrollment.StationDeviceId !== -1) {
            lSelected = 'C' + mEnrolleesData.OffenderEnrollment.StationDeviceId.toString();
        } else if (!isNullOrUndefined(mEnrolleesData.OffenderDeviceClusters) && mEnrolleesData.OffenderDeviceClusters.length > 0) {
            if (mEnrolleesData.OffenderEnrollment.StationDeviceId !== -1) {
                lItem = getDataItem(mEnrolleesData.OffenderEnrollment.StationDeviceId, 'DeviceClusters');
                if (!isNullOrUndefined(lItem)) {
                    lSelected = 'C' + lItem.Id.toString();
                }
            } else {
                lItem = mEnrolleesData.OffenderDeviceClusters[mEnrolleesData.OffenderDeviceClusters.length - 1];
                if (!isNullOrUndefined(lItem)) {
                    lSelected = 'C' + lItem.DeviceClusterId.toString();
                }
            }
        }
    } else if (mEnrolleesData.OffenderEnrollment.StationDeviceType === 105) {
        if (mEnrolleesData.OffenderEnrollment.StationDeviceId !== -1) {
            lItem = getDataItem(mEnrolleesData.OffenderEnrollment.StationDeviceId, 'Devices');
            if (!isNullOrUndefined(lItem)) {
                lSelected = 'D' + lItem.Id.toString();
            }
        }
    } else {
        if (mEnrolleesData.OffenderEnrollment.StationDeviceId !== -1) {
            lDevice = getDataItem(mEnrolleesData.OffenderEnrollment.StationDeviceId, 'Devices');
        } else {
            lAssignments = gCurrentDeviceAssignment[mEnrolleesData.OffenderCurrentId];
            for (lKey in lAssignments) {
                if (lAssignments.hasOwnProperty(lKey)) {
                    lItem = lAssignments[lKey];
                    lDevice = getDataItem(lItem.Id, 'Devices');
                }
            }
        }
        if (!isNullOrUndefined(lDevice) && [104, 109].indexOf(lDevice.ProductId) !== -1) {
            lSelected = 'D' + lDevice.Id.toString();
        }

    }
    mEnrolleesControls.StationCardView.selected(lSelected);

    
}

function setActiveState() {
    "use strict"
    if ($("#uDeviceAssignmentsWizardUnassignmentReasonEdit").val() == 17) {
        $('#uDeviceAssignmentsWizardStationEnableEidEdit').attr('checked', false);
    }
}

function offenderUnassignedAddOns(aSearchString) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lList;

    if (!isNullOrUndefined(aSearchString)) {
        lBuilder.AddNewExpressionConditional('Title', aSearchString, false, mRelationalOperatorEnum.Like(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('Description', aSearchString, false, mRelationalOperatorEnum.Like(), mLogicalOperatorEnum.Or());
    }
    lList = query(mEnrolleesData.AddOnsClean, lBuilder.RootExpression);

    return lList;
}
/**
 * offenderUnassignedStations@ function
 * This function will check for unassigned devices 
 * @param  {} aSearchString
 */
function offenderUnassignedStations(aSearchString) {
    "use strict";
    var lMasterBuilder = new SumoPredicateBuilder(),
        lChildBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression(),
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lProductIds,
        lDevices,
        lDeviceIds = [],
        lDeviceAssignments,
        lItem,
        lKey;


    if ([105, 999].indexOf(mEnrolleesData.StationDeviceTypeWizard) !== -1) {
        // BLUbox
        lProductIds = [105,999];
    } else if ([121].indexOf(mEnrolleesData.StationDeviceTypeWizard) !== -1 && (mEnrolleesData.OffenderEnrollment.TrackingDeviceType == 103 || mEnrolleesData.OffenderEnrollment.TrackingDeviceType == 151)) {
        lProductIds = [121];
    } else {
        var lTrackingDevice = getDataItem(mEnrolleesData.OffenderEnrollment.TrackingDeviceId, 'Devices');
        if (lTrackingDevice.HasDevicePairingSupport) {
            lProductIds = [111];
        } else {
            // BLUhome
            if (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId <= 2) {
                //allow only bluhome, and blubox for EID
                lProductIds = [104,109];
            } else if (lTrackingDevice.ProductId === 121) {
                lProductIds = [103, 151];
            } else if (lTrackingDevice.ProductId === 141) {
                // on blutag2 allow blubox,bluhome, blucelullar
                lProductIds = [104,109];
            } else {
                lProductIds = [104, 109];
            }
        }
    }
    lMasterBuilder.AddNewExpressionConditional('ProductId', lProductIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lMasterBuilder.AddNewExpressionConditional('OrganizationId', lEnrollee.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 103 || mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 141 || mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 151) {
        lChildBuilder.AddNewExpressionConditional('IsBluPlus', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
        lChildBuilder.AddNewExpressionConditional('ZoneId', 0, false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.Or());

        lMasterBuilder.Concatenate(lChildBuilder, mLogicalOperatorEnum.And());

        lChildBuilder.Clear();
    }

    if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 110) {
        lChildBuilder.Clear();
        lMasterBuilder.AddNewExpressionConditional('IsBluPlus', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lMasterBuilder.AddNewExpressionConditional('EnrolleeId', -1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        lChildBuilder.AddNewExpressionConditional('IsBluPlus', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lChildBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        //Or
        lChildBuilder.AddNewExpressionConditional('ZoneId', 0, false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.Or());
        lMasterBuilder.Concatenate(lChildBuilder, mLogicalOperatorEnum.Or());

        lChildBuilder.Clear();
    }


    if (mEnrolleesData.OffenderEnrollment.StationDeviceType !== 105) {
        lChildBuilder.Clear();
        lChildBuilder.AddNewExpressionConditional('IsAssignable', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 106) {
            lChildBuilder.AddNewExpressionConditional('IsMultiAssignable', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
        }
        lMasterBuilder.Concatenate(lChildBuilder, mLogicalOperatorEnum.And());
    }

    if (!isNullOrUndefined(aSearchString)) {
        lChildBuilder.Clear();
        lChildBuilder.AddNewExpressionConditional('Title', aSearchString, false, mRelationalOperatorEnum.Like(), mLogicalOperatorEnum.And());
        lChildBuilder.AddNewExpressionConditional('Description', aSearchString, false, mRelationalOperatorEnum.Like(), mLogicalOperatorEnum.Or());
    }
    lMasterBuilder.Concatenate(lChildBuilder, mLogicalOperatorEnum.And());

    lDeviceAssignments = gCurrentDeviceAssignment[lEnrollee.Id];
    if (!isNullOrUndefined(lDeviceAssignments)) {
        for (lKey in lDeviceAssignments) {
            if (lDeviceAssignments.hasOwnProperty(lKey)) {
                lItem = lDeviceAssignments[lKey];
                if (lProductIds.indexOf(lItem.ProductId) !== -1) {
                    lDeviceIds.push(lItem.Id);
                }
            }
        }
    }
    if (lDeviceIds.length > 0) {
        lMasterBuilder.AddNewExpressionConditional('Id', lDeviceIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.Or());
    }
    lDevices = query(mEnrolleesData.StationsClean, lMasterBuilder.RootExpression);
    lSort.addAscendingColumn('Title');
    lDevices = lSort.sort(lDevices);
    //mEnrolleesData.OffenderEnrollment.StationDeviceType = -1;
    return lDevices;
}


function uDeviceAssignmentsWizardStationSearch_OnChange() {
    "use strict";
    var lValue = $('#uDeviceAssignmentsWizardStationSearch').val(),
        lList;

    if ($('#uDeviceAssignmentsWizardBluTwoTab').is(':visible')) {
        lList = offenderUnassignedAddOns(lValue);
    } else {
        lList = offenderUnassignedStations(lValue);
    }
    mEnrolleesControls.StationCardView.setDataSource(lList);
}

function uDeviceAssignmentsWizardAddOnSearch_OnChange() {
    var lValue = $('#uDeviceAssignmentsWizardAddOnSearch').val(),
        lList = offenderUnassignedAddOns(lValue);

    mEnrolleesControls.AddOnCardView.setDataSource(lList);
}

function uDeviceAssignmentsWizardTab_OnClick(aDeviceType) {
    "use strict";
    function onComplete() {
        $(window).resize();
    }

    $('.AssignmentPopupTab.Selected').removeClass('Selected');
    $('.AssignmentPopupTab.' + aDeviceType).addClass('Selected');
    switch (aDeviceType) {
        case 'DeviceCluster':
            if (mEnrolleesData.OffenderEnrollment.StationDeviceType === -1) {
                mEnrolleesData.StationDeviceTypeWizard = 999;
                mEnrolleesData.OffenderEnrollment.StationDeviceType = 999;
            }
            $('#uDeviceAssignmentsWizardStationSearch').keyup();           
            break;
        case 'BluHome':
            mEnrolleesData.StationDeviceTypeWizard = -1;
            mEnrolleesData.OffenderEnrollment.StationDeviceType = -1;
            $('#uDeviceAssignmentsWizardStationSearch').keyup();
            break;
        case 'SoberTrack':
            mEnrolleesData.StationDeviceTypeWizard = 121;
            mEnrolleesData.OffenderEnrollment.StationDeviceType = 121;
            $('#uDeviceAssignmentsWizardStationSearch').keyup();
            break;
        case 'BluTwo':
            mEnrolleesData.StationDeviceTypeWizard = -1;
            mEnrolleesData.OffenderEnrollment.StationDeviceType = -1;
            $('#uDeviceAssignmentsWizardStationSearch').keyup();
            break;
        case 'Map':
            $('#uDeviceAssignmentsWizardMapHolder').show();
            $('#uDeviceAssignmentsWizardContactHolder').hide(onComplete);
            $(window).resize();
            break;
        case 'Contact':
            $('#uDeviceAssignmentsWizardMapHolder').hide();
            $('#uDeviceAssignmentsWizardContactHolder').show(onComplete);
            break;
    }
}
function uDeviceAssignmentsWizardAddOnDeviceCardView_OnSelectChange() {
    "use strict";
    var lSelected = mEnrolleesControls.AddOnCardView.selectedDataItem();

    if (isNullOrUndefined(lSelected)) {
        mEnrolleesData.OffenderEnrollment.AddOnDeviceId = -1;
        mEnrolleesData.OffenderEnrollment.AddOnDeviceType = -1;
        $('.sumo-wizard-blade-command .sumo-wizard-save').hide();
    } else {
        // blutwo
        $('.sumo-wizard-blade-command .sumo-wizard-save').show();
    }
}

function uDeviceAssignmentsWizardStationDeviceCardView_OnSelectChange(aSender, aSelectedIndex, aParams) {
    "use strict";
    var lSelected = mEnrolleesControls.StationCardView.selectedDataItem(),        
        lTrackingDevice = getDataItem(mEnrolleesData.OffenderEnrollment.TrackingDeviceId, 'Devices');

    $('.sumo-wizard-blade-3').show();

    if (isNullOrUndefined(lSelected)) {
        // null
        mEnrolleesData.OffenderEnrollment.StationDeviceId = -1;
        mEnrolleesData.OffenderEnrollment.StationDeviceType = -1;
        $('.sumo-wizard-blade-command .sumo-wizard-save').hide();
        $('.sumo-wizard-blade-command .sumo-wizard-next').hide();
        $('#BluBoxMapHolders').hide();
       
    } else if ([104, 109].indexOf(lSelected.ProductId) !== -1 || mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 110 || (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId <= 2)) {
        // bluhome
        $('.sumo-wizard-blade-command .sumo-wizard-save').hide();
        $('.sumo-wizard-blade-command .sumo-wizard-next').show();

        if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 110) {
            if (lSelected.Zone != '') {
                $('#BluBoxMapHolders').show();
                bluBoxZoneGeocode(getDataItem(lSelected.ZoneId, 'Zones'));
            } else {
                $('#BluBoxMapHolders').hide();
            }
        } else {
            $('#BluBoxMapHolders').hide();
        }
        
    } else if ([111].indexOf(lSelected.ProductId) !== -1) {
        $('.sumo-wizard-blade-command .sumo-wizard-save').show();
        $('.sumo-wizard-blade-command .sumo-wizard-next').hide();
        $('#BluBoxMapHolders').hide();
       
    }
    else {
        // blubox

        var lDeviceEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
        var lCurrentRiskLevel = getDataItem(lDeviceEnrollee.RiskLevelId + '.' + lDeviceEnrollee.OrganizationId + '.', 'RiskLevels');

        // hide the Save button if the enrollee risk level is EID Alternative or EID Enhanced
        if (lCurrentRiskLevel.EidTypeId == 1 || lCurrentRiskLevel.EidTypeId == 2) {
            $('.sumo-wizard-blade-command .sumo-wizard-save').hide();
        } else {
            $('.sumo-wizard-blade-command .sumo-wizard-save').show();
        }

        $('.sumo-wizard-blade-command .sumo-wizard-next').show();
        if (lSelected.Zone != '') {
            $('#BluBoxMapHolders').show();          
            bluBoxZoneGeocode(getDataItem(lSelected.ZoneId, 'Zones'));
        } else {
            $('#BluBoxMapHolders').hide();            
        }
        
    }
    if (!isNullOrUndefined(lSelected)) {
        offenderScheduleConfiguration_Check(lSelected.ProductId, lSelected.Id);
    } else {
        offenderScheduleConfiguration_Check(-1, -1);
    }

    if (!isNullOrUndefined(lSelected) && (lTrackingDevice.ProductId == 103 || lTrackingDevice.ProductId == 151) && lSelected.ProductId == 121) {
        $('#uDeviceAssignmentsWizard2Next').hide();
        $('.sumo-wizard-blade-3').hide();

    }
}





/**
 * uDeviceAssignmentsWizard_OnChanging@ function
 * This function is triggered when in the wizard changed steps.
 * eg. click next. 
 * @param  {} aSender
 * @param  {} aStepId
 * @param  {} aParams
 * @listens changing
 */
function uDeviceAssignmentsWizard_OnChanging(aSender, aStepId, aParams) {
    "use strict";
    var lSelected;
    //mEnrolleesData.OffenderEnrollment = new OffenderDeviceEnrollment(gUserDetails.UserId, mEnrolleesData.OffenderCurrentId);
    switch (aStepId) {
        case 1:
            mEnrolleesControls.DeviceAssignmentsMap.dispose();
            mEnrolleesControls.DeviceAssignmentsMap = null;
            mEnrolleesControls.TrackingDeviceCardView.unbind('databind', uDeviceAssignmentsWizardTrackingDeviceCardView_OnRender);
            $('#uDeviceAssignmentsWizardTrackingSearch').unbind('keyup', uDeviceAssignmentsWizardTrackingSearch_OnChange); //.unbind('change', uDeviceAssignmentsWizardTrackingSearch_OnChange)
            lSelected = mEnrolleesControls.TrackingDeviceCardView.selectedDataItem();
            if (!isNullOrUndefined(lSelected)) {
                mEnrolleesData.OffenderEnrollment.TrackingDeviceId = lSelected.Id;
                mEnrolleesData.OffenderEnrollment.TrackingDeviceType = lSelected.ProductId;
            }
            break;
        case 2:
            mEnrolleesControls.StationCardView.unbind('databind', uDeviceAssignmentsWizardStationDeviceCardView_OnRender);
            $('#uDeviceAssignmentsWizardStationSearch').unbind('keyup', uDeviceAssignmentsWizardStationSearch_OnChange); //.unbind('change', uDeviceAssignmentsWizardStationSearch_OnChange)
            lSelected = mEnrolleesControls.StationCardView.selectedDataItem();
            if (!isNullOrUndefined(lSelected)) {
                if (lSelected.HasDevicePairingSupport) {
                    mEnrolleesData.OffenderEnrollment.AddOnDeviceId = lSelected.Id;
                    mEnrolleesData.OffenderEnrollment.AddOnDeviceType = lSelected.ProductId;
                } else {
                    mEnrolleesData.OffenderEnrollment.StationDeviceId = lSelected.Id;
                    mEnrolleesData.OffenderEnrollment.StationDeviceType = lSelected.ProductId;
                }
            }
            break;
        case 3:
            populateFromEditView(mEnrolleesData.OffenderEnrollment, 'uDeviceAssignmentsWizard', 'Edit');
            if (isNullOrUndefined(mEnrolleesData.OffenderEnrollment.StationRfRange)) {
                mEnrolleesData.OffenderEnrollment.StationRfRange = -1;
			}
            if (isNullOrUndefined(mEnrolleesData.OffenderEnrollment.UnassignmentReason)) {
                mEnrolleesData.OffenderEnrollment.UnassignmentReason = -1;
            }
            //if (!isNullOrUndefined(mEnrolleesData.Validator)) {
            //    mEnrolleesData.Validator.dispose();
            //    mEnrolleesData.Validator = null;
            //}
            //if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsValidator)) {
            //    mEnrolleesControls.DeviceAssignmentsValidator.dispose();
            //    mEnrolleesControls.DeviceAssignmentsValidator = null;
            //}
            break;
    }
}
/**
 * 
 * @param  {} aSender
 * @param  {} aStepId
 * @param  {} aParams
 * @listens changed
 */
function uDeviceAssignmentsWizard_OnChanged(aSender, aStepId, aParams) {
    "use strict";
    var lData,
        lDisplayType = 'roadmap',
        lSystemPreferences = getUserPreferences(10),
        lDeviceEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lColumns,
        lDevice,
        lData,
        lItem,
        lKey,
        lBuilder;

    // check if device has blutwo support. if not skip page from 3 to 4
    function address_OnLoad(aParams, aData) {
        var lSelectedStationCard = mEnrolleesControls.StationCardView.selectedDataItem();             

        $('#uDeviceAssignmentsWizardLoadingBar').hide();
        $('.sumo-wizard-blade-content .BluPlusLoadItem').show();
        if (aData.length > 0) {
            if (!isNullOrUndefined(lSelectedStationCard) && lSelectedStationCard.ZoneId > 0) {
                $('#uDeviceAssignmentsWizardAddressGeocodedAlert').show();
                $('#uDeviceAssginmentVerificationPeriodHolder').hide();
                $('#uDeviceAssginmentOverLayZoneHolder').show();
                $('#uDeviceAssignmentOverLayZoneName').html(ZoneNameFormatter(lSelectedStationCard.ZoneId));
                $('#uDeviceAssignmentsWizardBluPlusVerificationPeriodEdit').val(0);
                $('#uDeviceAssignmentsWizardBluPlusTetheredAddressIdEdit').hide(); 
                populateEditView({}, [{ 'Id': 'BluPlusTetheredAddressId', 'Type': 'Dropdown', 'DataSource': [new EnrolleeAddress()], 'DataValueField': 'Id', 'DataTextField': 'Title' }], {}, 'uDeviceAssignmentsWizard', 'Edit');
            } else {
                var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
                if (checkOrganizationProperty(lEnrollee.OrganizationId, "auth_loc_verif_period_enabled") == "N") {
                    aData.unshift({})
                }
                populateEditView({}, [{ 'Id': 'BluPlusTetheredAddressId', 'Type': 'Dropdown', 'DataSource': aData, 'DataValueField': 'Id', 'DataTextField': 'Title' }], {}, 'uDeviceAssignmentsWizard', 'Edit');
            }            
        } else {
            $('#uDeviceAssginmentVerificationPeriodHolder').hide();
            if (!isNullOrUndefined(lSelectedStationCard) && lSelectedStationCard.ZoneId > 0) {
                $('#uDeviceAssignmentsWizard3Save').show();
                $('#uDeviceAssignmentsWizardAddressAlert').hide();
                $('#uDeviceAssginmentVerificationPeriodHolder').hide();
                $('#uDeviceAssginmentOverLayZoneHolder').show();
                $('#uDeviceAssignmentOverLayZoneName').html(ZoneNameFormatter(lSelectedStationCard.ZoneId));
                $('#uDeviceAssignmentsWizardBluPlusVerificationPeriodEdit').val(0);
                $('#uDeviceAssignmentsWizardBluPlusTetheredAddressIdEdit').hide();
            } else {
                $('#uDeviceAssignmentsWizard3Save').hide();
                $('#uDeviceAssignmentsWizardAddressAlert').show();
                $('#uDeviceAssignmentsWizardBluPlusTetheredAddressIdEdit').hide();
            }
        }
        if ([105, 999].indexOf(mEnrolleesData.OffenderEnrollment.StationDeviceType) !== -1) { //blubox and blubox group
            $('#uDeviceAssginmentVerificationPeriodHolder').show();
            $('#uVerificationPeriodDesc').show();
            var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
            if (checkOrganizationProperty(lEnrollee.OrganizationId, "auth_loc_verif_period_enabled") == "N") {
                $('#uDeviceAssignmentsWizardBluPlusVerificationPeriodEdit').removeClass('ValidateRequired ');
                $('#uDeviceAssignmentsWizard3Save').show();
                $('#uDeviceAssignmentsWizardAddressAlert').hide();
                $('#uDeviceAssignmentsWizardBluPlusTetheredAddressIdEdit').show();
            } else {
                $('#uDeviceAssignmentsWizardBluPlusVerificationPeriodEdit').addClass('ValidateRequired ');
            }
        }
        if ([104, 109].indexOf(mEnrolleesData.OffenderEnrollment.StationDeviceType) !== -1) { //bluHome
            $('#uDeviceAssignmentsWizardBluPlusVerificationPeriodEdit').hide();
            $('#uDeviceAssignmentsWizardBluPlusVerificationPeriodEdit').removeClass('ValidateRequired ');
            $('#uVerificationPeriodDesc').hide();
            $('#uDeviceAssginmentVerificationPeriodHolder').hide();
            lDevice = getDataItem(mEnrolleesData.OffenderEnrollment.StationDeviceId, 'Devices');
            if (lDevice.SupportFingerprintFlag) { //v4 or newer
                var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
                if (checkOrganizationProperty(lEnrollee.OrganizationId, "auth_loc_verif_period_enabled") == "N") {
                    $('#uDeviceAssignmentsWizard3Save').show();
                    $('#uDeviceAssignmentsWizardAddressAlert').hide();
                    $('#uDeviceAssignmentsWizardBluPlusTetheredAddressIdEdit').show();
                }
            } else { // older than v4
                $('#uAuthorizedLocationDescTitle').hide();
                $('#uAuthorizedLocationDesc').hide();
                $('#uAuthorizedLocationTitle').hide();
                $('#uDeviceAssignmentsWizard3Save').show();
                $('#uDeviceAssignmentsWizardAddressAlert').hide();
                $('#uDeviceAssignmentsWizardBluPlusTetheredAddressIdEdit').hide();
            }
        }
    }

    function generateAddressScheduleListView() {
        var lSchedules = mEnrolleesData.OffenderSchedules,
            lSelected = mEnrolleesControls.CardView.selectedDataItem(),
            lSelectedScheduleIds = [],
            lBuilder = new SumoPredicateBuilder(),
            lKey;

        lBuilder.AddNewExpressionConditional('EnrolleeId', lSelected.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ScheduleType', 6, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lSchedules = query(lSchedules, lBuilder.RootExpression);

        //if (isNullOrUndefined(mEnrolleesControls.SchedulesBluPlusConfigurationListView)) {
        mEnrolleesControls.SchedulesBluPlusConfigurationListView = new sumo.controls.ListView('uDeviceAssignmentsWizardBluPlusSchedulesListView', 'uDeviceAssignmentsWizardBluPlusSchedulesListViewHolder', {
            'keyField': 'Id', 'selectMethod': 'auto', 'cssClass': 'VeritracksListView', 'canUnselect': true
        }, [
            { 'id': 'Description', 'title': 'Description', 'dataField': 'Name', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
           // { 'id': 'Target', 'title': 'Target', 'dataField': 'TargetName', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': null },
           // { 'id': 'TargetType', 'title': 'Target Type', 'dataField': 'TargetTypeName', 'width': 'autoData', 'minWidth': 75, 'sortable': false, 'cssClass': null, 'formatMethod': null },
            //{ 'id': 'StartTime', 'title': 'Start', 'dataField': 'StartTime', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'date', 'formatMethod': displayTime },
            { 'id': 'EndTime', 'title': 'Check-In', 'dataField': 'EndTime', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'date', 'formatMethod': displayTime },
          //  { 'id': 'ScheduleType', 'title': 'Type', 'dataField': 'ScheduleType', 'width': 'autoData', 'minWidth': 85, 'sortable': false, 'cssClass': null, 'formatMethod': null },
           // { 'id': 'ZoneScheduleType', 'title': 'Zone Category', 'dataField': 'ZoneScheduleType', 'width': 'autoData', 'minWidth': 85, 'sortable': false, 'cssClass': null, 'formatMethod': scheduleZoneTypeFormatter },
            { 'id': 'IsSunday', 'title': 'S', 'dataField': 'IsSunday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'dataType': 'boolean', 'cssClass': null, 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsMonday', 'title': 'M', 'dataField': 'IsMonday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsTuesday', 'title': 'T', 'dataField': 'IsTuesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsWednesday', 'title': 'W', 'dataField': 'IsWednesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsThursday', 'title': 'R', 'dataField': 'IsThursday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsFriday', 'title': 'F', 'dataField': 'IsFriday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsSaturday', 'title': 'S', 'dataField': 'IsSaturday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false }
        ]);

        //}

        mEnrolleesControls.SchedulesBluPlusConfigurationListView.setDataSource(lSchedules);
        mEnrolleesControls.SchedulesBluPlusConfigurationListView.bind('selectedchanged', uBluPlusSchedulesListView_OnSelectChange);

        for (lKey in lSchedules) {
            if (lSchedules.hasOwnProperty(lKey)) {
                lItem = lSchedules[lKey];
                if (lItem.IsEnabled) {
                    lSelectedScheduleIds.push(lItem.Id);
                }
            }
        }
        mEnrolleesControls.SchedulesBluPlusConfigurationListView.selected(lSelectedScheduleIds);
        $('#uDeviceAssignmentsWizardBluPlusSchedulesListViewHolder').show();
    }

    function stationRendered(aSender, aData, aParams) {
        aSender.unbind('databind', stationRendered);
        aSender.selected(aParams);
    }


    function addOnRendered(aSender, aData, aParams) {
        aSender.unbind('databind', addOnRendered);
        aSender.selected(aParams);
    }

    $('#BluHomeV4Initiate').hide();
    switch (aStepId) {
        case 1:
            uDeviceAssignmentsWizardTab_OnClick('Map');
            if (!isNullOrUndefined(lDeviceEnrollee)) {                
                var lCurrentRiskLevel = getDataItem(lDeviceEnrollee.RiskLevelId + '.' + lDeviceEnrollee.OrganizationId + '.', 'RiskLevels');                
                if (lCurrentRiskLevel.EidTypeId == 1 || lCurrentRiskLevel.EidTypeId == 2) {
                    GetEIdReservationQuota(mEnrolleesData.OffenderCurrentId, uGetEidReservation_OnSuccess, Sad);
                }                
            }
            mEnrolleesData.OffenderEnrollment.StationDeviceId = -1;
            mEnrolleesData.OffenderEnrollment.StationDeviceType = -1;
            mEnrolleesData.OffenderEnrollment.AddOnDeviceId = -1;
            mEnrolleesData.OffenderEnrollment.AddOnDeviceType = -1;

            if (!isNullOrUndefined(lSystemPreferences['MapDisplayType'])) {
                lDisplayType = lSystemPreferences['MapDisplayType'].Value;
            }
            mEnrolleesControls.DeviceAssignmentsMap = new sumo.maps.GoogleMapControl('uDeviceAssignmentsWizardMap', 'uDeviceAssignmentsWizardMapHolder', { 'displayType': lDisplayType, 'mapTypeId_OnChange': mapDisplayType_OnChange });
            mEnrolleesControls.DeviceAssignmentsMap.layerAdd('Contact', {
                'renderType': 'marker',
                'doesPlayback': true,
                'isVisible': true,
                'clickEventHandler': null,
                'zIndexStart': 90000
            });
            mEnrolleesControls.DeviceAssignmentsMap.layerAdd('Labels', {
                'renderType': 'label',
                'doesPlayback': true,
                'isVisible': true,
                'clickEventHandler': null,
                'zIndexStart': 800000
            });

            lColumns = [
                { 'id': 'ContactDate', 'title': 'Date/Time', 'dataField': 'ContactDate', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'formatMethod': DisplayShortDateTime },
                { 'id': 'Status', 'title': 'Status', 'dataField': 'Status', 'width': 'autoData', 'minWidth': 36, 'sortable': false, 'cssClass': null, 'formatMethod': ContactStatusNameFormatter },
                { 'id': 'RecordCount', 'title': 'Points', 'dataField': 'RecordCount', 'width': 'autoData', 'minWidth': 36, 'sortable': false, 'cssClass': null, 'formatMethod': null },
                { 'id': 'GpsRecordCount', 'title': 'GPS', 'dataField': 'GpsRecordCount', 'width': 'autoData', 'minWidth': 25, 'sortable': false, 'cssClass': null, 'formatMethod': null },
                { 'id': 'PercentGps', 'title': '% GPS', 'dataField': 'PercentGps', 'width': 'autoData', 'minWidth': 40, 'sortable': false, 'cssClass': null, 'formatMethod': DisplayPercent },
                { 'id': 'BatteryLevel', 'title': '', 'dataField': 'BatteryLevel', 'width': 'autoData', 'minWidth': 24, 'sortable': false, 'cssClass': 'CenterImage', 'formatMethod': inventoryBatteryLevelFormatter, 'canResize': false },
                { 'id': 'BatteryVoltage', 'title': '', 'dataField': 'BatteryVoltage', 'width': 'autoData', 'minWidth': 24, 'sortable': false, 'cssClass': 'CenterImage', 'formatMethod': DisplayVolts, 'canResize': false }
            ];

            mEnrolleesControls.DeviceAssignmentsContactList = new sumo.controls.ListView('uDeviceAssignmentsWizardListView', 'uDeviceAssignmentsWizardListViewHolder', { 'keyField': 'Id', 'selectMethod': 'none', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);

            mEnrolleesControls.TrackingDeviceCardView = new sumo.controls.CardView('uDeviceAssignmentsWizardTrackingDeviceCardView', 'uDeviceAssignmentsWizardTrackingDeviceCardViewHolder', { 'cardTemplate': 'Interface/Enrollees.Offenders.Profile.Assignments.Popup.Tracking.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': true, 'cssClass': 'VeritracksCardView', 'keyField': 'Id', 'keyFieldType': 'number' });
            mEnrolleesControls.TrackingDeviceCardView.bind('selectedchanged', uDeviceAssignmentsWizardTrackingDeviceCardView_OnSelectChange);
            mEnrolleesControls.TrackingDeviceCardView.bind('databind', uDeviceAssignmentsWizardTrackingDeviceCardView_OnRender);
            $('#uDeviceAssignmentsWizardTrackingSearch').keyup(uDeviceAssignmentsWizardTrackingSearch_OnChange).keyup(); //.change(uDeviceAssignmentsWizardTrackingSearch_OnChange)
            $('.sumo-wizard-blade-command .sumo-wizard-save').hide();
            $('.sumo-wizard-blade-command .sumo-wizard-next').hide();
            bluBoxMap_Dispose();
            break;
        case 2:
            var lDevice = getDataItem(mEnrolleesData.OffenderEnrollment.TrackingDeviceId, 'Devices'),
                lProducts = getDataItems("Products"),
                lBuilder = new SumoPredicateBuilder(),
                lAvialableDevices = [],
                lDeviceProduct;

            bluBoxGeocode_Init();
            $('.sumo-wizard-blade-command .sumo-wizard-save').hide();
            $('.sumo-wizard-blade-command .sumo-wizard-next').hide();
            $('#uDeviceAssignmentsWizardScheduleAlert').hide();

            mEnrolleesData.OffenderEnrollment.StationPhoneNumber = '';
            mEnrolleesData.OffenderEnrollment.StationRfRange = -1;

            mEnrolleesControls.StationCardView = new sumo.controls.CardView('uDeviceAssignmentsWizardStationDeviceCardView', 'uDeviceAssignmentsWizardStationDeviceCardViewHolder', { 'cardTemplate': 'Interface/Enrollees.Offenders.Profile.Assignments.Popup.Station.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': true, 'cssClass': 'VeritracksCardView', 'keyField': 'Id', 'keyFieldType': 'number' });
            mEnrolleesControls.StationCardView.bind('selectedchanged', uDeviceAssignmentsWizardStationDeviceCardView_OnSelectChange);
            mEnrolleesControls.StationCardView.bind('databind', uDeviceAssignmentsWizardStationDeviceCardView_OnRender);

            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional("Id", mEnrolleesData.OffenderEnrollment.TrackingDeviceType, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional("IsActive", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lProducts = query(lProducts, lBuilder.RootExpression);

            for (var productKey in lProducts) {
                if (lProducts.hasOwnProperty(productKey)) {
                    lDeviceProduct = lProducts[productKey];
                    break;
                }
            }

            // help
            if (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId <= 2) {
                $('.AssignmentPopupContentHolder .BluTagEid').show();
                $('.AssignmentPopupContentHolder .BluTag').hide();
                $('.AssignmentPopupContentHolder .BluPlus').hide();
                $('.AssignmentPopupContentHolder .BluBand').hide();
                $('.AssignmentPopupContentHolder .BluTwo').hide();
                $('.AssignmentPopupContentHolder .SoberTrack').hide();
                $('.AssignmentPopupContentHolder .BluTagInt').hide();
                //} else if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 103) {
            } else if (isBluTagIntProduct(lDeviceProduct)) {
                $('.AssignmentPopupContentHolder .BluTagEid').hide();
                $('.AssignmentPopupContentHolder .BluTag').hide();
                $('.AssignmentPopupContentHolder .BluPlus').hide();
                $('.AssignmentPopupContentHolder .BluBand').hide();
                $('.AssignmentPopupContentHolder .BluTwo').hide();
                $('.AssignmentPopupContentHolder .SoberTrack').hide();
                $('.AssignmentPopupContentHolder .BluTagInt').show();
            } else if (isBLUTagProduct(lDeviceProduct)) {
                $('.AssignmentPopupContentHolder .BluTagEid').hide();
                $('.AssignmentPopupContentHolder .BluPlus').hide();
                $('.AssignmentPopupContentHolder .BluBand').hide();
                if (lDevice.HasDevicePairingSupport) {
                    $('.AssignmentPopupContentHolder .BluTwo').show();
                    $('.AssignmentPopupContentHolder .BluTag').hide();
                } else {
                    $('.AssignmentPopupContentHolder .BluTwo').hide();
                    $('.AssignmentPopupContentHolder .BluTag').show();
                }
                $('.AssignmentPopupContentHolder .SoberTrack').hide();
                $('.AssignmentPopupContentHolder .BluTagInt').hide();
            } else if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 106) {
                $('.AssignmentPopupContentHolder .BluTagEid').hide();
                $('.AssignmentPopupContentHolder .BluTag').hide();
                $('.AssignmentPopupContentHolder .BluPlus').hide();
                $('.AssignmentPopupContentHolder .BluBand').show();
                $('.AssignmentPopupContentHolder .BluTwo').hide();
                $('.AssignmentPopupContentHolder .SoberTrack').hide();
                $('.AssignmentPopupContentHolder .BluTagInt').hide();
            } else if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 110) {
                $('.AssignmentPopupContentHolder .BluTagEid').hide();
                $('.AssignmentPopupContentHolder .BluTag').hide();
                $('.AssignmentPopupContentHolder .BluPlus').show();
                $('.AssignmentPopupContentHolder .BluBand').hide();
                $('.AssignmentPopupContentHolder .BluTwo').hide();
                $('.AssignmentPopupContentHolder .SoberTrack').hide();
                $('.AssignmentPopupContentHolder .BluTagInt').hide();
            } else if (isSoberTrackProduct(lDeviceProduct)) {
                $('.AssignmentPopupContentHolder .BluTagEid').hide();
                $('.AssignmentPopupContentHolder .BluTag').hide();
                $('.AssignmentPopupContentHolder .BluPlus').hide();
                $('.AssignmentPopupContentHolder .BluBand').hide();
                $('.AssignmentPopupContentHolder .BluTwo').hide();
                $('.AssignmentPopupContentHolder .SoberTrack').show();
                $('.AssignmentPopupContentHolder .BluTagInt').hide();                
            }
            offenderScheduleConfiguration_Check(-1, -1);
            var lTrackingDevice = getDataItem(mEnrolleesData.OffenderEnrollment.TrackingDeviceId, 'Devices');
            if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 110 || (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId <= 2)) {
                // blu+ or has eid
                if ((!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId <= 2)) {
                    $('#uDeviceAssignmentsWizardBluHomeTab').show();

                } else {
                    $('#uDeviceAssignmentsWizardBluHomeTab').hide();
                }

                $('#uDeviceAssignmentsWizardBluTwoTab').hide();
                $('#uDeviceAssignmentsWizardSoberTrackTab').hide();                
                uDeviceAssignmentsWizardTab_OnClick('BluHome');
            } else if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 106) {
                // bluband
                $('#uDeviceAssignmentsWizardDeviceClusterTab').hide();
                $('#uDeviceAssignmentsWizardBluTwoTab').hide();
                $('#uDeviceAssignmentsWizardSoberTrackTab').hide();
                uDeviceAssignmentsWizardTab_OnClick('BluHome');                
            } else if (lTrackingDevice.HasDevicePairingSupport) {
                $('#uDeviceAssignmentsWizardDeviceClusterTab').hide();
                $('#uDeviceAssignmentsWizardBluHomeTab').hide();
                uDeviceAssignmentsWizardTab_OnClick('BluTwo');
                $('#uDeviceAssignmentsWizardSoberTrackTab').hide();
            }  else if (isBLUTagProduct(lDeviceProduct)) {
                $('#uDeviceAssignmentsWizardBluTwoTab').hide();
                uDeviceAssignmentsWizardTab_OnClick('BluHome');
            } else if (isBluTagIntProduct(lDeviceProduct)) {
                $('#uDeviceAssignmentsWizardBluTwoTab').hide();
                $('#uDeviceAssignmentsWizardBluHomeTab').hide();
                $('#uDeviceAssignmentsWizardSoberTrackTab').hide();
                uDeviceAssignmentsWizardTab_OnClick('BluHome');
            }else {
                $('#uDeviceAssignmentsWizardBluTwoTab').hide();
                $('#uDeviceAssignmentsWizardSoberTrackTab').hide();
                uDeviceAssignmentsWizardTab_OnClick('BluHome');
            }

            /**
            if (isBLUTagProduct(lDeviceProduct)) {
                lAvialableDevices = [104, 105, 109, 121];
            } else {
                lAvialableDevices = [104, 105, 109];
            }
            **/

            if (isBLUTagProduct(lDeviceProduct) || isBluTagIntProduct(lDeviceProduct)) {
                lAvialableDevices = blutagPairingProducts();
            } else {
                lAvialableDevices = nonBluTagPairingProducts();
            }
              
            
            var lSelectedValue = mEnrolleesData.OffenderEnrollment.StationDeviceId;
            if (lSelectedValue === -1) {
                lData = gCurrentDeviceAssignment[mEnrolleesData.OffenderEnrollment.Id];
                if (!isNullOrUndefined(lData)) {
                    for (lKey in lData) {
                        if (lData.hasOwnProperty(lKey)) {
                            lItem = lData[lKey];
                            lDevice = getDataItem(lItem.Id, 'Devices');
                            if (lAvialableDevices.indexOf(lDevice.ProductId) !== -1) {
                                lSelectedValue = lDevice.Id;
                            }
                        }
                    }
                }
            }
            if (lSelectedValue !== -1) {
                mEnrolleesControls.StationCardView.bind('databind', stationRendered, lSelectedValue);
            }
            $('#uDeviceAssignmentsWizardStationSearch').keyup(uDeviceAssignmentsWizardStationSearch_OnChange).keyup(); //.change(uDeviceAssignmentsWizardStationSearch_OnChange)
            break;
        case 3:
            //applyUserPermissions([39]);
            $('#uDeviceAssignmentsWizardUnassignmentReasonEdit').change(setActiveState);

            $('.sumo-wizard-blade-content .UnassignmentItem').hide();
            $('.sumo-wizard-blade-content .BluHomeItem').hide();
            $('.sumo-wizard-blade-content .DeviceClusterItem').hide();
            $('.sumo-wizard-blade-content .EidItem').hide();
            $('.sumo-wizard-blade-content .EidQuotaFilledItem').hide();
            $('.sumo-wizard-blade-content .BluPlusPreLoadItem').hide();
            $('.sumo-wizard-blade-content .BluPlusLoadItem').hide();
            $('.sumo-wizard-blade-content .BlutagIntPreLoadItem').hide();
            // unassign
            lData = gCurrentDeviceAssignment[mEnrolleesData.OffenderEnrollment.Id];
            if (!isNullOrUndefined(lData) && lData.length > 0) {
                lData = getDataItems('DeviceChangeReason');

                lBuilder = new SumoPredicateBuilder();
                lBuilder.AddNewExpressionConditional('EnrolleeTypeId', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                if (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId <= 2) {
                    if (mEnrolleesData.OffenderEidReservation.StatusId === 2) {
                        lBuilder.AddNewExpressionConditional('Id', [16, 17], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                    }
                } else {
                    lBuilder.AddNewExpressionConditional('Id', [16, 17], false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
                }
                    lData = query(lData, lBuilder.RootExpression);

                populateEditView({}, [{ 'Id': 'UnassignmentReason', 'Type': 'Dropdown', 'DataSource': lData, 'LocaleName': 'DeviceChangeReason', 'DataValueField': 'Id', 'DataTextField': 'Description' }], {}, 'uDeviceAssignmentsWizard', 'Edit', localizeDataItem);
                $('.sumo-wizard-blade-content .UnassignmentItem').show();
            } else {
                $('.sumo-wizard-blade-content .UnassignmentItem').remove();
            }
            if ([104, 105, 109, 999].indexOf(mEnrolleesData.OffenderEnrollment.StationDeviceType) !== -1) {
                var lAbsencesEnabled = veritracks.system.clientSetting('veritracksabsenceschedules');
                var lScheduleDisplayOld = displayOldScheduleUILoggedInOri(mEnrolleesData.OffenderCurrentId);

                if (lScheduleDisplayOld && lAbsencesEnabled) {
                    $('#uAbsenceScheduleEnabled').show()
                }

                if (!lAbsencesEnabled || !lScheduleDisplayOld) {
                    $('#uAbsenceScheduleEnabled').hide();
                }

            }
            // bluhome
            if ([104, 109].indexOf(mEnrolleesData.OffenderEnrollment.StationDeviceType) !== -1) {
				lData = getDataItems('RfRange');
				populateEditView({}, [{ 'Id': 'StationRfRange', 'Type': 'Dropdown', 'DataSource': lData, 'LocaleName': 'RFRange', 'DataValueField': 'Value', 'DataTextField': 'Description' }], {}, 'uDeviceAssignmentsWizard', 'Edit', localizeDataItem);
				$('.sumo-wizard-blade-content .BluHomeItem').show();
                $('.sumo-wizard-blade-content .DeviceClusterItem:not(.BluHomeItem)');
                var lDropDown = $('#uDeviceAssignmentsWizardStationRfRangeEdit'),
					lIndex;
				lDevice = getDataItem(mEnrolleesData.OffenderEnrollment.StationDeviceId, 'Devices');
                if (lDevice.SupportFingerprintFlag) {
                    $('#BluHomeV4Initiate').show();
                    $('#uDeviceAssignmentsWizardBluPlusVerificationPeriodEdit').addClass('ValidateSuccess');
                    $('#uDeviceAssignmentsWizardBluPlusVerificationPeriodEdit').val('0');
                    $('.cEnrolleeVerificationPeriodDesc').hide()
                    $('.cEnrolleeOriginatingPhoneDesc').hide()
                    $('.cEnrolleeOriginatingPhone').hide();
                    $('#uDeviceAssignmentsWizardStationPhoneNumberEdit').hide();
                } else { //hides this for bluhome older thant v4
                    $('#uDeviceAssginmentVerificationPeriodHolder').hide();
                    $('#uDeviceAssignmentsWizardBluPlusVerificationPeriodEdit').addClass('ValidateSuccess');
                    $('#uDeviceAssignmentsWizardBluPlusVerificationPeriodEdit').val('0');
                }
                for (lKey in lData) {
                    if (lData.hasOwnProperty(lKey)) {
                        if (lData[lKey].Description == "HIGH") {
                            lIndex = lData[lKey].Id;
                        }
                    }
				}
				lDropDown.prop('selectedIndex', lIndex - 1);


            // device cluster
            } else if ([105, 999].indexOf(mEnrolleesData.OffenderEnrollment.StationDeviceType) !== -1) {
                $('.sumo-wizard-blade-content .DeviceClusterItem').show();
                $('.sumo-wizard-blade-content .BluHomeItem:not(.DeviceClusterItem)').remove();
            } else {
                $('.sumo-wizard-blade-content .DeviceClusterItem').remove();
                $('.sumo-wizard-blade-content .BluHomeItem').remove();
            }
            // bluplus
            // STOP-582
            if ([103, 141, 106, 110, 151].indexOf(mEnrolleesData.OffenderEnrollment.TrackingDeviceType) !== -1) {
                if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 141) {
                    $('.sumo-wizard-blade-content .BlutagIntPreLoadItem').show();
                    $('#uDeviceAssignmentsWizardBluPlusVerificationPeriodEdit').show();
                } else {
                    $('.sumo-wizard-blade-content .BluPlusPreLoadItem').show();
                }
                //fix eid bug
                //if ([109].indexOf(mEnrolleesData.OffenderEnrollment.StationDeviceType) !== -1) {
                //    $('.sumo-wizard-blade-content .EidItem').remove();
                //    $('#uDeviceAssignmentsWizardStationEnableEidEdit').attr('checked', false);
               // }

                enrolleeAddress_Init(mEnrolleesData.OffenderEnrollment.Id, address_OnLoad);
                generateAddressScheduleListView(); 
            } else {
                $('.sumo-wizard-blade-content .BluPlusPreLoadItem').remove();
            }

            if (IsEIDProduct(mEnrolleesData.OffenderEnrollment.StationDeviceType)) {
                // eid
                if (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId <= 2) {
                    if (mEnrolleesData.OffenderEidReservation.StatusId === 2) {
                        $('#uDeviceAssignmentsWizardStationEnableEidEdit').attr('checked', 'checked');
                        if (moment(mEnrolleesData.OffenderEidReservation.EndDate).year() !== 0)
                            $('#uDeviceAssignmentsWizardStationEndDateEdit').val(displayShortDate(mEnrolleesData.OffenderEidReservation.EndDate));
                    }
                    populateDateView('#uDeviceAssignmentsWizardStationEndDateEdit', deviceAssignmentsEidConfigurationDates_OnChange);
                    //mEnrolleesControls.DeviceAssignmentsValidator = new Validator('uEidDateRangeValidator', mRegexValidation);
                    //mEnrolleesControls.DeviceAssignmentsValidator.IsValid();
                    $('.sumo-wizard-blade-content .EidItem').show();
                    $('#uDeviceAssignmentsWizardStationEnableEidEdit').attr('checked', true);
                } else {
                    var lRiskLevel = getEnrolleeRiskLevel(mEnrolleesData.OffenderCurrentId);

                    EidQuotaCheck(lRiskLevel, function (quota) {
                        if (quota == -1) {
                            $('.sumo-wizard-blade-content .EidItem').remove();
                            $('#uDeviceAssignmentsWizardStationEnableEidEdit').attr('checked', false);
                        } else if (quota == 1) {
                            populateDateView('#uDeviceAssignmentsWizardStationEndDateEdit', deviceAssignmentsEidConfigurationDates_OnChange);
                            //mEnrolleesControls.DeviceAssignmentsValidator = new Validator('uEidDateRangeValidator', mRegexValidation);
                            //mEnrolleesControls.DeviceAssignmentsValidator.IsValid();
                            $('.sumo-wizard-blade-content .EidItem').show();
                            $('#uDeviceAssignmentsWizardStationEnableEidEdit').attr('checked', true);
                        } else if (quota == 0) {
                            $('.sumo-wizard-blade-content .EidQuotaFilledItem').show();
                            $('.sumo-wizard-save').hide();

                        }
                    })
                }
            }
            mEnrolleesData.Validator = new Validator('uDeviceAssignmentsWizard3Content', mRegexValidation);
            bluBoxMap_Dispose();
            break;
    }
    offenderScheduleConfiguration_Check(mEnrolleesData.OffenderEnrollment.StationDeviceType, mEnrolleesData.OffenderEnrollment.StationDeviceId);
    veritracks.localization.localize('#' + aSender.Id);
}

function blutagPairingProducts() {
    "use strict";
    var lProducts = getDataItems("Products"),
        lProductsPaired = [],
        lProductIds = [],
        lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional("IsADockingStation", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
    lBuilder.AddNewExpressionConditional("IsAAlcoholUnit", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
    lBuilder.AddNewExpressionConditional("SupportsRFGrouping", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
    lBuilder.AddNewExpressionConditional("IsActive", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lProductsPaired = query(lProducts, lBuilder.RootExpression);

    for (var key in lProductsPaired) {
        if (lProductsPaired.hasOwnProperty(key)) {
            lProductIds.push(lProductsPaired[key].Id);
        }//end of if
    }//end of for

    return lProductIds;
}

function DockingRFProducts() {
    "use strict";
    var lProducts = getDataItems("Products"),
        lProductsPaired = [],
        lProductIds = [],
        lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional("IsADockingStation", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
    lBuilder.AddNewExpressionConditional("SupportsRFGrouping", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
    lBuilder.AddNewExpressionConditional("IsActive", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lProductsPaired = query(lProducts, lBuilder.RootExpression);

    for (var key in lProductsPaired) {
        if (lProductsPaired.hasOwnProperty(key)) {
            lProductIds.push(lProductsPaired[key].Id);
        }//end of if
    }//end of for

    lProductIds.push(999);

    return lProductIds;
}

function IsEIDProduct(aIdList) {
    var lIdList = DockingRFProducts();    
    if (lIdList.indexOf(aIdList) != -1) {
        return true;
    }

    return false;
}

function nonBluTagPairingProducts() {
    "use strict";
    var lProducts = getDataItems("Products"),
        lProductsPaired = [],
        lProductIds = [],
        lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional("IsADockingStation", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
    lBuilder.AddNewExpressionConditional("SupportsRFGrouping", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
    lBuilder.AddNewExpressionConditional("IsActive", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lProductsPaired = query(lProducts, lBuilder.RootExpression);

    for (var key in lProductsPaired) {
        if (lProductsPaired.hasOwnProperty(key)) {
            lProductIds.push(lProductsPaired[key].Id);
        }//end of if
    }//end of for

    return lProductIds;
}

function isBLUTagProduct(aProduct) {
    "use strict";
    if (!isNullOrUndefined(aProduct) && aProduct.IsATrackingUnitOffender && aProduct.SupportsRFExpander && aProduct.SupportsDockingStation && aProduct.SupportsAlcoholAccessary) {
        return true;
    } else {
        return false;
    }
}

function isBluTagIntProduct(aProduct) {
    "use strict";
    if (isBLUTagProduct(aProduct) && aProduct.Id == 141) {
        return true;
    } else {
        return false;
    }
}

function isGPSProduct(aProductId) {
    "use strict";
    var lProducts = getDataItems("Products"),
        lProductsPaired = [],
        lReturnStatus = false,
        lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional("Id", aProductId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
    lProductsPaired = query(lProducts, lBuilder.RootExpression);

    for (var key in lProductsPaired) {
        if (lProductsPaired.hasOwnProperty(key)) {
            if (lProductsPaired[key].IsATrackingUnitOffender) {
                lReturnStatus = true;
                break;
            }
        }
    }

    return lReturnStatus;

}

function isSoberTrackProduct(aProduct) {
    "use strict";
    if (!isNullOrUndefined(aProduct) && aProduct.IsAAlcoholUnit && aProduct.IsATrackingUnitOffender) {
        return true;
    } else {
        return false;
    }
}

function uDeviceAssignmentsWizard_OnSave(aSender, aStepId, aParams) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lEnrollment = mEnrolleesData.OffenderEnrollment,
        lEnrollee = getDataItem(lEnrollment.Id, 'Enrollees'),
        lAssignments = gCurrentDeviceAssignment[lEnrollment.Id],
        lSchedules = mEnrolleesData.OffenderSchedules,
        lScheduleTypes = offenderScheduleConfiguration_Check(mEnrolleesData.OffenderEnrollment.StationDeviceType, mEnrolleesData.OffenderEnrollment.StationDeviceId),
        lDevice,
        lDevices = [],
        //lIsAlreadyAssigned = false,
        lDeviceCluster,
        lDeviceClusterDevice,
        lDeviceClusterEnrollees = [],
        lBluPlusConfiguration,
        lEidReservation,
        lSchedule,
        lSchedulesWrite = [],
        lBluBoxSchedules = [],
        lAddressScheduleWrite = [],
        lEnrolleeAddressWriteId,
        lItem,
        lKey,
        lTransactionId = moment().format("YYYYMMDDHHmmss"),
        lTimeZone = getEnrolleeTimeZone(lEnrollment.Id);

    lEnrollment.TransactionId = lTransactionId;
    lEnrollee.TransactionId = lTransactionId;

    function bluPlusAddressSchedulesSave() {
        "use strict";
        var lSelected = mEnrolleesControls.CardView.selectedDataItem(),
            lFilteredSchedules = mEnrolleesData.OffenderSchedules,
            lSelectedScheduleIds = mEnrolleesControls.SchedulesBluPlusConfigurationListView.selected(),
            lItem,
            lKey,
            lBuilder = new SumoPredicateBuilder();

        lBuilder.AddNewExpressionConditional('EnrolleeId', lSelected.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ScheduleType', 6, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        lFilteredSchedules = query(lFilteredSchedules, lBuilder.RootExpression);

        for (lKey in lFilteredSchedules) {
            if (lFilteredSchedules.hasOwnProperty(lKey)) {
                lItem = lFilteredSchedules[lKey];
                lItem = $.extend({}, lItem);
                lItem.IsEnabled = (lSelectedScheduleIds.indexOf(lItem.Id) !== -1);
                lAddressScheduleWrite.push(lItem);
            }
        }
    }

    function deactivateDeviceClusterLink() {
        var lBuilder = new SumoPredicateBuilder(),
            lData = getDataItems('DeviceClusterEnrollee'),
            lKey,
            lItem;

        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrollment.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lData = query(lData, lBuilder.RootExpression);

        for (lKey in lData) {
            if (lData.hasOwnProperty(lKey)) {
                lItem = lData[lKey];
                if (lEnrollment.StationDeviceType !== 999 || lEnrollment.StationDeviceId !== lItem.DeviceClusterId) {
                    lItem = $.extend({}, lItem);
                    lItem.IsActive = false;
                    lDeviceClusterEnrollees.push(lItem);
                //} else if (lEnrollment.StationDeviceType === 999 && lEnrollment.StationDeviceId === lItem.DeviceClusterId) {
                //    lIsAlreadyAssigned = true;
                }
            }
        }
    }


    if (isNullOrUndefined(mEnrolleesData.Validator) || mEnrolleesData.Validator.IsValid()) {
        setLoadingBarStatus('uEnrolleesDeviceAssignmentsWizardLoadingBar', 'uDeviceAssignmentsWizardContentHolder', true);

        lEnrollee = $.extend({}, lEnrollee);
        lEnrollee.IsAssigned = true;

        if (!isNullOrUndefined(lAssignments)) {
            for (lKey in lAssignments) {
                if (lAssignments.hasOwnProperty(lKey)) {
                    lItem = lAssignments[lKey];
                    if (lItem.Id !== lEnrollment.TrackingDeviceId && ([104, 109].indexOf(lEnrollment.StationDeviceType) === -1 || ([104, 109].indexOf(lEnrollment.StationDeviceType) !== -1 && lItem.Id !== lEnrollment.StationDeviceId))) {
                        lDevice = getDataItem(lItem.Id, 'Devices');
                        lDevice = $.extend({}, lDevice);
                        lDevice.TransactionId = lTransactionId;
                        lDevice.Status = 5;
                        lDevice.UserId = gUserDetails.UserId;
                        lDevices.push(lDevice);
                    }
                }
            }
        }

        lDevice = getDataItem(lEnrollment.TrackingDeviceId, 'Devices');
        if (lDevice.Status === 5) {
            lDevice = $.extend({}, lDevice);
            lDevice.Status = 4;
            lDevice.TransactionId = lTransactionId;
            lDevice.UserId = gUserDetails.UserId;
            lDevices.push(lDevice);
        }
        lDevice = null;

        if (lEnrollment.AddOnDeviceId !== -1) {
            lDevice = getDataItem(lEnrollment.AddOnDeviceId, 'Devices');
            if (lDevice.Status === 5) {
                lDevice = $.extend({}, lDevice);
                lDevice.Status = 4;
            }
        }

        if ([110, 103, 141, 106, 151].indexOf(lEnrollment.TrackingDeviceType) !== -1) {
            //tags
            var lBLUPlusUnPairedAssignment = veritracks.system.clientSetting('BluPlusUnpairedEnable');
                if (isNullOrUndefined(lBLUPlusUnPairedAssignment)) {
                    lBLUPlusUnPairedAssignment = false;
                }
            lBluPlusConfiguration = new BluPlusConfiguration();
            lBluPlusConfiguration.Id = lEnrollment.TrackingDeviceId;
            lBluPlusConfiguration.TransactionId = lTransactionId; 
            lBluPlusConfiguration.EnrolleeId = lEnrollment.Id;
            populateFromEditView(lBluPlusConfiguration, 'uDeviceAssignmentsWizardBluPlus', 'Edit');
            lBluPlusConfiguration.VerificationPeriod = Math.abs(parseInt(lBluPlusConfiguration.VerificationPeriod));
            if (isNaN(lBluPlusConfiguration.VerificationPeriod)) {
                lBluPlusConfiguration.VerificationPeriod = 0;
            }
            if (!lBLUPlusUnPairedAssignment && !isNullOrUndefined(mEnrolleesControls.SchedulesBluPlusConfigurationListView))
                bluPlusAddressSchedulesSave();

            lEnrolleeAddressWriteId = lBluPlusConfiguration.TetheredAddressId;
            if (lBluPlusConfiguration.TetheredAddressId == -1 || isNullOrUndefined(lBluPlusConfiguration.TetheredAddressId)) { // bbg with zone
                lBluPlusConfiguration = null;
            }
		}

        if ($('#uDeviceAssignmentsWizardStation247ScheduleEdit').is(':checked')) {
            lSchedule = new OffenderSchedule();
            lSchedule.EnrolleeId = lEnrollee.Id;
            lSchedule.EntityId = lEnrollment.StationDeviceId;
            if ([104, 109].indexOf(lEnrollment.StationDeviceType) !== -1) {
                lSchedule.ScheduleType = 2;
                lDevice = getDataItem(lEnrollment.StationDeviceId, 'Devices');
                lSchedule.Name = 'Auto Generated: ' + lDevice.SerialNumber;
            } else if ([105, 999].indexOf(lEnrollment.StationDeviceType) !== -1) {
                lSchedule.ScheduleType = 3;
                if (lEnrollment.StationDeviceType === 105) {
                    lDevice = getDataItem(lEnrollment.StationDeviceId, 'Devices');
                    lSchedule.Name = 'Auto Generated: BBG-' + lDevice.SerialNumber;
                } else {
                    lDevice = getDataItem(lEnrollment.StationDeviceId, 'DeviceClusters');
                    lSchedule.Name = 'Auto Generated: ' + lDevice.Name;
                }
            }
            lSchedule.TransactionId = lTransactionId;
            lSchedule.StartTime.setSeconds(0);
            lSchedule.StartTime.setMilliseconds(0);

            lSchedule.EndTime.setHours(23);
            lSchedule.EndTime.setMinutes(59);
            lSchedule.EndTime.setSeconds(0);
            lSchedule.EndTime.setMilliseconds(0);

            lSchedule.IsSunday = true;
            lSchedule.IsMonday = true;
            lSchedule.IsTuesday = true;
            lSchedule.IsWednesday = true;
            lSchedule.IsThursday = true;
            lSchedule.IsFriday = true;
            lSchedule.IsSaturday = true;
            lSchedule.StartTime = convertTimeToUTC(lSchedule.StartTime, lTimeZone.TimeZoneName);
            lSchedule.EndTime = convertTimeToUTC(lSchedule.EndTime, lTimeZone.TimeZoneName);

            lSchedulesWrite.push(lSchedule);
        }
        lDevice = null;

        if (lScheduleTypes.length > 0) {
            lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('ScheduleType', lScheduleTypes, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            //lBuilder.AddNewExpressionConditional('IsEnabled', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());  //FogBugz Ticket 1453
            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lSchedules = query(lSchedules, lBuilder.RootExpression);
            lBuilder.Clear();

            //for (lKey in lSchedules) {
            //    if (lSchedules.hasOwnProperty(lKey)) {
            //        lItem = lSchedules[lKey];
            //        lItem.IsEnabled = false;
            //        lItem.IsActive = false;
            //        lItem.TransactionId = lTransactionId;
            //        lSchedulesWrite.push(lItem);
            //    }
            //}

            lSchedules = mEnrolleesData.OffenderSchedules;
            lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('EntityId', -1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsEnabled', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            if ([104, 109, 999].indexOf(lEnrollment.StationDeviceType) !== -1) {
                if (lEnrollment.StationDeviceType === 999) {
                    // Device Cluster
                    lBuilder.AddNewExpressionConditional('ScheduleType', 3, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                } else {
                    // BluHome
                    lBuilder.AddNewExpressionConditional('ScheduleType', 2, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                }
                lSchedules = query(lSchedules, lBuilder.RootExpression);
                lBuilder.Clear();
                for (lKey in lSchedules) {
                    if (lSchedules.hasOwnProperty(lKey)) {
                        lItem = lSchedules[lKey];
                        lItem.EntityId = lEnrollment.StationDeviceId;
                        lItem.TransactionId = lTransactionId;
                        lSchedulesWrite.push(lItem);
                    }
                }
            } else if (lEnrollment.StationDeviceType === 105) {
                // BluBox
                lBuilder.AddNewExpressionConditional('ScheduleType', 3, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBluBoxSchedules = query(lSchedules, lBuilder.RootExpression);
                lBuilder.Clear();
            }
        } else if (lEnrollment.StationDeviceType === 105) {
            // BluBox
            lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('EntityId', -1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsEnabled', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('ScheduleType', 3, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBluBoxSchedules = query(lSchedules, lBuilder.RootExpression);
            lBuilder.Clear();
        }

        deactivateDeviceClusterLink();
        if (lEnrollment.StationDeviceType === 999) {
            // device cluster

            //if (!lIsAlreadyAssigned) {
            lDeviceClusterEnrollees.push(new DeviceClusterEnrollee(lEnrollment.StationDeviceId, lEnrollment.Id, true, lTransactionId));
            var lCluster = getDataItem(lEnrollment.StationDeviceId, 'DeviceClusters');
            lCluster.EnrolleeCount = lCluster.EnrolleeCount + 1;
            lCluster.TransactionId = lTransactionId;
            WriteSingle(lCluster, ClusterDevice_OnUpdate, null, null, false);
            //}
            lEnrollment.StationDeviceType = -1;
            lEnrollment.StationDeviceId = -1;
        } else if (lEnrollment.StationDeviceType === 105) {
            // blubox
             
            lDevice = getDataItem(lEnrollment.StationDeviceId, 'Devices');
            if (!isNullOrUndefined(lDevice)) {
                lDeviceCluster = new DeviceCluster();
                lDeviceCluster.Name = 'BBG-' + lDevice.SerialNumber;
                lDeviceCluster.Description = 'Auto-generated during assignment.';
                lDeviceCluster.TransactionId = lTransactionId;
                lDeviceCluster.OrganizationId = lEnrollee.OrganizationId;
                lDeviceClusterDevice = new DeviceClusterDevice(-1, lEnrollment.StationDeviceId, true);
                lDeviceClusterDevice.TransactionId = lTransactionId;
                lDeviceClusterEnrollees.push(new DeviceClusterEnrollee(-1, lEnrollment.Id, true, lTransactionId));

                lEnrollment.StationDeviceType = -1;
                lEnrollment.StationDeviceId = -1;
                lDevice.Status = 4;
                lDevice.TransactionId = lTransactionId;
                lDevice.UserId = gUserDetails.UserId;
                lDevices.push(lDevice);
            }
        }
        else if (lEnrollment.StationDeviceType === 111) {
            // blutwo
            lDevice = getDataItem(lEnrollment.StationDeviceId, 'Devices');
            if (!isNullOrUndefined(lDevice)) {
                lDevice.Status = 4;
                lDevice.TransactionId = lTransactionId;
                lDevice.UserId = gUserDetails.UserId;
                lDevices.push(lDevice);
            }
        } else if (lEnrollment.StationDeviceType === 121) {
            lDevice = getDataItem(lEnrollment.StationDeviceId, 'Devices');
            lEnrollment.AlcoholDeviceId = lEnrollment.StationDeviceId;
            lEnrollee.AlcoholDeviceFlag = 1;
            lEnrollment.StationDeviceId = -1;
            lEnrollment.StationDeviceType = -1;
            if (!isNullOrUndefined(lDevice)) {
                lDevice.Status = 4;
                lDevice.TransactionId = lTransactionId;
                lDevice.UserId = gUserDetails.UserId;
                lDevices.push(lDevice);
            }
            
        }

        //if is sobertrack
        
        if (lEnrollment.TrackingDeviceType == 121) {
            //lDevice = getDataItem(lEnrollment.TrackingDeviceId, 'Devices');
            lEnrollment.AlcoholDeviceId = lEnrollment.TrackingDeviceId;
            lEnrollee.AlcoholDeviceFlag = 1;
            //if (!isNullOrUndefined(lDevice)) {
             //   lDevice.Status = 4;
              //  lDevices.push(lDevice);
            //}
        }
        
        lDevice = null;

        if (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId <= 2) {
            var lNewEndDate,
                lOldEndDate = displayShortDate(mEnrolleesData.OffenderEidReservation.EndDate);
            var lRiskLevel = getEnrolleeRiskLevel(mEnrolleesData.OffenderCurrentId);

            if (mEnrolleesData.OffenderEidReservation.StatusId === 1 && $('#uDeviceAssignmentsWizardStationEnableEidEdit').is(':checked')) {
                lEidReservation = $.extend({}, mEnrolleesData.OffenderEidReservation);
                lEidReservation.StatusId = 2;
                lEidReservation.StartDate = moment()._d;
                lEidReservation.UserId = gUserDetails.UserId;
                lEidReservation.EidTypeId = lRiskLevel.EidTypeId;
                lEidReservation.TransactionId = lTransactionId;
            } else if (mEnrolleesData.OffenderEidReservation.StatusId === 2 && !$('#uDeviceAssignmentsWizardStationEnableEidEdit').is(':checked')) {
                lEidReservation = $.extend({}, mEnrolleesData.OffenderEidReservation);
                lEidReservation.StatusId = 5;
                lEidReservation.UserId = gUserDetails.UserId;
                lEidReservation.EidTypeId = lRiskLevel.EidTypeId;
                lEidReservation.TransactionId = lTransactionId;
            }
            lNewEndDate = $('#uDeviceAssignmentsWizardStationEndDateEdit').val();
            if (($.trim(lNewEndDate).length > 0) && (lNewEndDate != lOldEndDate)) {
                if (isNullOrUndefined(lEidReservation)) {
                    lEidReservation = $.extend({}, mEnrolleesData.OffenderEidReservation);
                }
                lEidReservation.UserId = gUserDetails.UserId;
                lEidReservation.EidTypeId = lRiskLevel.EidTypeId;
                lEidReservation.EndDate = new Date(lNewEndDate);
            }
        } else if ($('#uDeviceAssignmentsWizardStationEnableEidEdit').is(':checked')) {
            var lRiskLevel = getEnrolleeRiskLevel(mEnrolleesData.OffenderCurrentId);
            lEidReservation = new EidReservation();
            lNewEndDate = $('#uDeviceAssignmentsWizardStationEndDateEdit').val();
            lEidReservation.EndDate = new Date(lNewEndDate);
            lEidReservation.StartDate = moment()._d;
            lEidReservation.StatusId = 2;
            lEidReservation.UserId = gUserDetails.UserId;
            lEidReservation.EidTypeId = lRiskLevel.EidTypeId;
            lEidReservation.EnrolleeId = mEnrolleesData.OffenderCurrentId;
        }
    }
       
    // write process


    if (isNullOrUndefined(mEnrolleesData.Validator) || mEnrolleesData.Validator.IsValid()) {
        if (!isNullOrUndefined(mEnrolleesData.Validator)) {
            mEnrolleesData.Validator.dispose();
            mEnrolleesData.Validator = null;
        }
        $('.sumo-wizard-close').hide();
        $('.sumo-wizard-next').hide();
        $('.sumo-wizard-save').hide();
        $('.sumo-wizard-previous').hide();
        if (isNullOrUndefined(lAssignments)) {
            lAssignments = [];
        }

        var lParams = {
            'Enrollment': lEnrollment,
            'Devices': lDevices,
            'Enrollee': lEnrollee,
            'DeviceCluster': lDeviceCluster,
            'DeviceClusterDevice': lDeviceClusterDevice,
            'DeviceClusterEnrollees': lDeviceClusterEnrollees,
            'BluPlusConfiguration': lBluPlusConfiguration,
            'BluPlusAddressSchedules': lAddressScheduleWrite,
            'EidReservation': lEidReservation,
            'Schedules': lSchedulesWrite,
            'BluBoxSchedules': lBluBoxSchedules
        };

        if (!isNullOrUndefined(lEnrolleeAddressWriteId) && lEnrolleeAddressWriteId != -1 && lEnrolleeAddressWriteId != "") {
            updateGetEnrolleeAddressTether(lEnrolleeAddressWriteId);
        }

        if (checkOrganizationProperty(lEnrollee.OrganizationId, 'enrollment_notif_up_to_date') === 'Y' && mEnrolleesControls.DeviceAssignmentsListView.getDataSource().length > 0) {
            mEnrolleesData.EnrolleeChangeReasonHolder = lParams;
            mEnrolleesControls.DeviceAssignmentsWizard.close();
            DisplayEnrollmentInfoUpToDatePopup(aStepId, lAssignments.length);
        } else {

            if ((aStepId == 1 || aStepId == 2) && (lAssignments.length > 0)) {
                mEnrolleesData.EnrolleeChangeReasonHolder = lParams;
                mEnrolleesControls.DeviceAssignmentsWizard.close();
                uDisplayUnassignmentReasonPopup();
            } else {
                if (mEnrolleesData.OffenderEnrollment.StationDeviceId !== -1) {//checks if the device is a bluhome, and that its version supports fingerprint setup , and checks if the user has permissions. 
                    lDevice = getDataItem(mEnrolleesData.OffenderEnrollment.StationDeviceId, 'Devices');
                    if (lDevice.SupportFingerprintFlag && $('#uDeviceAssignmentsWizardStation247InitiateVerification').is(':checked')) {
                        lParams.Enrollment.InitializeFingerprint = 1;
                    }
                }
                SaveDeviceAssignment(lParams);
            }
        }
   }
}


function updateGetEnrolleeAddressTether(aAddressId) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional('Id', aAddressId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.EnrolleeAddress.AssemblyQualifiedName, lBuilder.RootExpression, 0, updateGetEnrolleeAddressTether_OnLoad, failure, null, null, 0);
    
}

function updateGetEnrolleeAddressTether_OnLoad(aParams, aData) {
    "use strict";
    if (aData && aData.length > 0) {
        var tetheredAddress = aData[0];
        tetheredAddress.TetheredLocationFlag = true;
        WriteSingle(tetheredAddress, updateEnrolleeAddressTether_OnSuccess, failure, null, true);
    }
}

function updateEnrolleeAddressTether_OnSuccess(aParams, aData) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cEnrolleeAddressSaved'));
}

function SaveDeviceAssignment(aParams) {

    for (var key in aParams.Devices){
        if (aParams.Devices.hasOwnProperty(key)){
            if (aParams.Devices[key].ProductId == 121){
                var lAlcoholAssignments = new DeviceAssignment(aParams.Devices[key].Id, aParams.Enrollee.Id);
                if (aParams.Enrollment.AlcoholDeviceId == -1) {
                    lAlcoholAssignments.EndDate = new Date();                   
                }
                setDataItem(aParams.Devices[key].Id, 'AlcoholDeviceAssignments', lAlcoholAssignments);
            }
        }
    }
   
    WriteSingle(aParams.Enrollment, enrollment_OnSuccess, failure, aParams, true);
}

function failure(aParams, a, b, c) {
    var l = '';
}

function ClusterDevice_OnUpdate(aParams, aData) {
    "use strict";
    setDataItem(aData.Id, 'DeviceClusters', aData);
}
function deviceAssignments_OnUpdate(aSender, aItem, aParams) {
    mCache.unbind('CurrentDeviceAssignmentsupdated', deviceAssignments_OnUpdate);
    enrolleesDataListConverter();
    enrolleesStationListConverter();
    mEnrolleesData.OffenderScheduleConfiguration = null;
    window.location.hash = 'Enrollees.Offenders.Profile.Assignments.' + aParams.Enrollee.Id;
    if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsWizard)) {
        mEnrolleesControls.DeviceAssignmentsWizard.close();
    }
}

function removeAbsenceSchedulesAssignment(aEnrolleeId) {
    var lBuilder = new SumoPredicateBuilder();
    var lAbsences = [];
    var lKey;

    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ScheduleType', 7, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lAbsences = query(mEnrolleesData.OffenderSchedules, lBuilder.RootExpression);
    for (lKey in lAbsences) {
        if (lAbsences.hasOwnProperty(lKey)) {
            lItem = lAbsences[lKey];
            lItem.IsActive = false;
            updateOffenderScheduleCache(lItem);
        }
    }
}

function schedule_OnSuccess(aParams, aData) {
    var lItem,
        lKey,
        lAssignments = gCurrentDeviceAssignment[aParams.Enrollee.Id],
        lVictimTabEnabled = veritracks.system.clientSetting('VictimMonitoringEnabled'),
        lIsBluBox = false;
        lNow = new Date();
    FixDates(aData);
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            updateOffenderScheduleCache(lItem);
            if (lItem.ScheduleType == 3 || lItem.ScheduleType == 4)
                lIsBluBox = true;
            enrolleesOffenderScheduleUpdate_OnSuccess(lItem);
        }
    }
    if (lIsBluBox)
        removeAbsenceSchedulesAssignment(aParams.Enrollee.Id);

    for (lKey in lAssignments) {
        if (lAssignments.hasOwnProperty(lKey)) {
            lItem = lAssignments[lKey];
            lItem.EndDate = lNow;
        }
    }

    var lVictimCheck = false;

    for (var lKeyB in aParams.Devices) {
        if (aParams.Devices.hasOwnProperty(lKeyB)) {
            if (aParams.Devices[lKeyB].ProductId == 103 || aParams.Devices[lKeyB].ProductId == 151) {
                lVictimCheck = true;
            }
        }
    }

    // check for victim
    if (lVictimTabEnabled && aParams.Enrollee.HasVictimFlag) {
        var lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('OffenderId', aParams.Enrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.VictimProfile.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleeVictimProfileEnrollmentRead_OnComplete, failure, aParams, null, 0);
    }
    mCache.bind('CurrentDeviceAssignmentsupdated', deviceAssignments_OnUpdate, aParams);
    mCache.UpdateItem('CurrentDeviceAssignments');
    

    if ($('#uDeviceAssignmentsWizardStation247ScheduleAddAbsencesEdit').is(':checked')) {
        window.setTimeout(function () {
            enrolleeSchedulePopup_Init(aParams.Enrollee.Id);
            enrolleesVeritracksCalendarEnterCarveMode();
        }, 1000)
    }
}

function enrolleeVictimProfileEnrollmentRead_OnComplete(aParams, aData) {
    "use strict";
    var lEnrollment = aParams.Enrollment;
    var lVictimDevice;
    var lVictimAssignment;
    var lVictim;
    var lOffenderDevice;
    if (aData.length > 0) {
        lVictim = aData[0];
        lVictimAssignment = gCurrentDeviceAssignment[lVictim.Id];
        for (var lKey in lVictimAssignment) {
            if (lVictimAssignment.hasOwnProperty(lKey)) {
                lVictimDevice = getDataItem(lVictimAssignment[lKey].Id, 'Devices');
            }
        }
        if (lEnrollment.TrackingDeviceType == 103 || lEnrollment.TrackingDeviceType == 151) {
            lOffenderDevice = getDataItem(lEnrollment.TrackingDeviceId, 'Devices');
            WriteVictimDeviceAssignmentPR(lVictim, lVictimDevice, lOffenderDevice, enrolleeVictimEnrolleeCompleteAssignment_Success, failure, null);
        } else {
            WriteVictimDeviceAssignmentPR(lVictim, lVictimDevice, null, offenderUnAssignmentVictim_OnSuccess, victimAssignment_OnFailure,
            {
                'Enrollee': aParams.Enrollee,
                'Victim': lVictim
            });
        }
    }
}

function enrolleeVictimEnrolleeCompleteAssignment_Success(aParams, aData) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cEnrolleeVictimOffenderPairComplete'));
}

function eidReservation_OnSuccess(aParams, aData) {
    if (!isNullOrUndefined(aData)) {
        FixDates(aData);
        mEnrolleesData.OffenderEidReservation = aData;
    }

    if (aParams.Schedules.length) {
        if (!isNullOrUndefined(aParams.DeviceCluster)) {
            var lKey;

            for (lKey in aParams.Schedules) {
                if (aParams.Schedules.hasOwnProperty(lKey)) {
                    aParams.Schedules[lKey].EntityId = aParams.DeviceCluster.Id;
                }
            }
        }
        saveSchedulesMultiDay(aParams.Schedules, schedule_OnSuccess, aParams)
    } else {
        schedule_OnSuccess(aParams, []);
    }
}

function bluPlusAddressSchedules_OnSuccess(aParams, aData) {
    var lItem,
        lKey;

    if (!isNullOrUndefined(aData)) {
        FixDates(aData);
        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                updateOffenderScheduleCache(lItem);
            }
        }
        mEnrolleesControls.SchedulesBluPlusConfigurationListView.unbind('selectedchanged', uBluPlusSchedulesListView_OnSelectChange);
    }

    if (!isNullOrUndefined(aParams.EidReservation)) {
        WriteSingle(aParams.EidReservation, eidReservation_OnSuccess, failure, aParams, true);
    } else {
        eidReservation_OnSuccess(aParams, null);
    }
}

function bluPlusConfiguration_OnSuccess(aParams, aData) {
    if (!isNullOrUndefined(aParams.BluPlusAddressSchedules) && count(aParams.BluPlusAddressSchedules) > 0) {
        WriteMultiple(aParams.BluPlusAddressSchedules, bluPlusAddressSchedules_OnSuccess, failure, aParams, true);
    } else {
        bluPlusAddressSchedules_OnSuccess(aParams, null);
    }
}

function deviceClusterEnrollee_OnSuccess(aParams, aData) {
    var lItem,
        lKey;
    FixDates(aData);
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            setDataItem(lItem.Id, 'DeviceClusterEnrollee', lItem);
        }
    }
   

    if (!isNullOrUndefined(aParams.BluPlusConfiguration)) {
        var lbpConfigWrite = new BluPlusConfiguration();
        lbpConfigWrite.EnrolleeId = aParams.BluPlusConfiguration.EnrolleeId;
        lbpConfigWrite.Id = aParams.BluPlusConfiguration.Id;
        lbpConfigWrite.TetheredAddressId = aParams.BluPlusConfiguration.TetheredAddressId == "" ? -1 : aParams.BluPlusConfiguration.TetheredAddressId;
        lbpConfigWrite.VerificationPeriod = aParams.BluPlusConfiguration.VerificationPeriod;
        lbpConfigWrite.TransactionId = aParams.BluPlusConfiguration.TransactionId;
        WriteSingle(lbpConfigWrite, bluPlusConfiguration_OnSuccess, failure, aParams, true);
    } else {
        bluPlusConfiguration_OnSuccess(aParams, null);
    }
}

function deviceClusterDevice_OnSuccess(aParams, aData) {
    if (!isNullOrUndefined(aData)) {
        FixDates(aData);
        setDataItem(aData.Id, 'DeviceClusterDevices', aData);
    }

    if (aParams.DeviceClusterEnrollees.length > 0) {
        WriteMultiple(aParams.DeviceClusterEnrollees, deviceClusterEnrollee_OnSuccess, failure, aParams, true);
    } else {
        deviceClusterEnrollee_OnSuccess(aParams, []);
    }
}

function deviceCluster_OnSuccess(aParams, aData) {
    var lItem,
        lKey;
    if (!isNullOrUndefined(aData)) {
        FixDates(aData);
        aParams.DeviceCluster = aData;
        setDataItem(aData.Id, 'DeviceClusters', aData);
        if (!isNullOrUndefined(aParams.DeviceClusterDevice)) {
            aParams.DeviceClusterDevice.DeviceClusterId = aData.Id;
        }
        if (!isNullOrUndefined(aParams.DeviceClusterEnrollees)) {
            for (lKey in aParams.DeviceClusterEnrollees) {
                if (aParams.DeviceClusterEnrollees.hasOwnProperty(lKey)) {
                    lItem = aParams.DeviceClusterEnrollees[lKey];
                    if (lItem.DeviceClusterId === -1) {
                        lItem.DeviceClusterId = aData.Id;
                    }
                }
            }
        }
        for (lKey in aParams.BluBoxSchedules) {
            if (aParams.BluBoxSchedules.hasOwnProperty(lKey)) {
                lItem = aParams.BluBoxSchedules[lKey];
                lItem.EntityId = aData.Id;
                aParams.Schedules.push(lItem);
            }
        }
    }


    if (!isNullOrUndefined(aParams.DeviceClusterDevice)) {
        WriteSingle(aParams.DeviceClusterDevice, deviceClusterDevice_OnSuccess, failure, aParams, true);
    } else {
        deviceClusterDevice_OnSuccess(aParams, null);
    }
}

function enrollee_OnSuccess(aParams, aData) {
    FixDates(aData);
    aData.InMyOrganization = (gUserDetails.OrganizationIds.indexOf(aData.OrganizationId) !== -1);
    setDataItem(aData.Id, 'Enrollees', aData);
    if (!isNullOrUndefined(aParams.DeviceCluster)) {
        WriteSingle(aParams.DeviceCluster, deviceCluster_OnSuccess, failure, aParams, true);
    } else {
        deviceCluster_OnSuccess(aParams, null);
    }
}

function devices_OnSuccess(aParams, aData) {
    var lItem,
        lKey;
    FixDates(aData);
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            setDataItem(lItem.Id, 'Devices', lItem);
        }
    }
    // TODO: RE-PAIRING
    StalkerController.PairingVictimsWithEnrollee(mEnrolleesData.OffenderProfileCurrentVictims);
    aParams.Enrollee.Birthdate = BirthDateStringFormatter(aParams.Enrollee.Birthdate);
    WriteSingle(aParams.Enrollee, enrollee_OnSuccess, failure, aParams, false);

}

function enrollment_OnSuccess(aParams, aData) {
    "use strict";    

    if (aParams.Devices.length > 0) {
        WriteMultiple(aParams.Devices, devices_OnSuccess, failure, aParams, false);
    } else {
        devices_OnSuccess(aParams, []);
    }
}

function uDeviceAssignmentsWizard_OnClose(aSender, aStepId, aParams) {
    "use strict";
    setLoadingBarStatus('uEnrolleesDeviceAssignmentsWizardLoadingBar', 'uDeviceAssignmentsWizardContentHolder', false);
    $('#uWizardHolder').hide();
    mEnrolleesControls.DeviceAssignmentsWizard.unbind('changing', uDeviceAssignmentsWizard_OnChanging);
    mEnrolleesControls.DeviceAssignmentsWizard.unbind('changed', uDeviceAssignmentsWizard_OnChanged);
    mEnrolleesControls.DeviceAssignmentsWizard.unbind('save', uDeviceAssignmentsWizard_OnSave);
    mEnrolleesControls.DeviceAssignmentsWizard.unbind('close', uDeviceAssignmentsWizard_OnClose);
    if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsMap)) {
        mEnrolleesControls.DeviceAssignmentsMap.dispose();
        mEnrolleesControls.DeviceAssignmentsMap = null;
    }
    if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsWizard)) {
        mEnrolleesControls.DeviceAssignmentsWizard.dispose();
        mEnrolleesControls.DeviceAssignmentsWizard = null;
    }
    if (!isNullOrUndefined(mEnrolleesControls.TrackingDeviceCardView)) {
        mEnrolleesControls.TrackingDeviceCardView.dispose();
        mEnrolleesControls.TrackingDeviceCardView = null;
    }
    //if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsValidator)) {
    //    mEnrolleesControls.DeviceAssignmentsValidator.dispose();
    //    mEnrolleesControls.DeviceAssignmentsValidator = null;
    //}
    if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsContactList)) {
        mEnrolleesControls.DeviceAssignmentsContactList.dispose();
        mEnrolleesControls.DeviceAssignmentsContactList = null;
    }
    if (!isNullOrUndefined(mEnrolleesControls.SchedulesBluPlusConfigurationListView)) {
        mEnrolleesControls.SchedulesBluPlusConfigurationListView.dispose();
        mEnrolleesControls.SchedulesBluPlusConfigurationListView = null;
    }
    if (!isNullOrUndefined(mEnrolleesData.Validator)) {
        mEnrolleesData.Validator.dispose();
        mEnrolleesData.Validator = null;
    }
}
/**
 * uEnrolleesAddAssignment_OnClick@ function
 * This event function reacts on click button add assignment. 
 */
function uEnrolleesAddAssignment_OnClick() {
    "use strict";

    
    var openWizard = function(){
        offenderScheduleConfiguration_Init(mEnrolleesData.OffenderCurrentId);
        mEnrolleesData.OffenderEnrollment = new OffenderDeviceEnrollment(gUserDetails.UserId, mEnrolleesData.OffenderCurrentId);
        mEnrolleesData.AddOnsAvailable = checkAddOnPerOrganization();
        if (mEnrolleesData.AddOnsAvailable)
            deviceAddOnDataListConverter();
        mEnrolleesControls.DeviceAssignmentsWizard = new sumo.controls.Wizard('uDeviceAssignmentsWizard', 'uWizardHolder', {
            'steps': [
                { 'fileName': 'Interface/Enrollees.Offenders.Profile.Assignments.Wizard/Tracking.html', 'allowSave': true, 'hidden': false, 'pageTitle': 1 },
                { 'fileName': 'Interface/Enrollees.Offenders.Profile.Assignments.Wizard/Station.html', 'allowSave': true, 'hidden': false, 'pageTitle': 2 },
                { 'fileName': 'Interface/Enrollees.Offenders.Profile.Assignments.Wizard/Configuration.html', 'allowSave': true, 'hidden': false, 'pageTitle': 3 }],
            'FixPages': { 'UseSkip': false, 'AddOne': 2, 'SubtractOne': 4 },
            'HidablePage': 3

        });
        $('#uWizardHolder').show();
        mEnrolleesControls.DeviceAssignmentsWizard.bind('changing', uDeviceAssignmentsWizard_OnChanging);
    mEnrolleesControls.DeviceAssignmentsWizard.bind('changed', uDeviceAssignmentsWizard_OnChanged);
    mEnrolleesControls.DeviceAssignmentsWizard.bind('save', uDeviceAssignmentsWizard_OnSave);
    mEnrolleesControls.DeviceAssignmentsWizard.bind('close', uDeviceAssignmentsWizard_OnClose);
    };
    if(StalkerController.IsEnrolleeSAMAPaired(mEnrolleesData.OffenderCurrentId)){
        StalkerController.PreventUpdateAssignment(function(){
            openWizard();
        },function(){
            
        });
    }else { 
        openWizard();
    }
    
    
    
}

function uGetEidReservation_OnSuccess(aParams, aData) {    
    if (aData && aData.length > 0) {        
        $("#uDeviceAssignmentWizardEidQuotaHolder").show();        
        $("#uDeviceAssignmentWizardEidQuotaHolder").text('EID Quota ' + aData[0].CurrentEidCount + ' of ' + aData[0].MaxEidCount);
    }
}

function CloseEiQuotaPopup() {
    ClosePopup();
    mEnrolleesControls.EidQuotaListView.dispose();
    mEnrolleesControls.EidQuotaListView = null;

}

function uGetEidReservationQuotaList_OnSuccess(aParams, aData) {
    if (aData) {
        $("#uEidPopupTitleQuota").text(aData[0].CurrentEidCount + ' of ' + aData[0].MaxEidCount + ' used');
        var count = 1;
        for (var key in aData) {
            if (aData.hasOwnProperty(key)) {
                aData[key].Id = count;
                count++;
            }
        }
        mEnrolleesControls.EidQuotaListView.setDataSource(aData);
    }
}

function uGetEidReservation_PopupOnClick() {
    var lButtonBar = GenerateButtonCommandBar(),
        lOrganizationName = 'Unknown',
        lCurrentEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lColumns = [            
            { 'id': 'Id', 'title': localizeWrapper('cId'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'EnrolleName', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'EnrolleeName', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': null }
        ];

    lOrganizationName = OrganizationNameFormatter(lCurrentEnrollee.OrganizationId);
    GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'CloseEiQuotaPopup();').appendTo(lButtonBar);
    DisplayPopup(localizeWrapper('cEnrolleeEidQuota') + '<span>' + lOrganizationName + '</span>&nbsp;' + '<span id="uEidPopupTitleQuota"></span>', '<div id="uEidQuotaListHolder" style="height: inherit;"></div>', lButtonBar, false);
    mEnrolleesControls.EidQuotaListView = new sumo.controls.ListView('uEidQuotaListView', 'uEidQuotaListHolder', { 'keyField': 'Id', 'selectMethod': 'single', 'cssClass': 'VeritracksListView vListViewContained', 'canUnselect': false }, lColumns);
    GetEIdReservationQuota(mEnrolleesData.OffenderCurrentId, uGetEidReservationQuotaList_OnSuccess, Sad);
    
}
function WriteAudibleTone(aEnrolleeId,aDeviceId,aFlag){
    var lCurrentEnrollee = getDataItem(aEnrolleeId, 'Enrollees');
    // var aAudibleToneFLag = lCurrentEnrollee.AudibleToneFlag?0:1;
    WriteEnrolleeAudibleOnLowBatt(aEnrolleeId,aDeviceId,gUserDetails.UserId,aFlag, function aSuccess(aParams,aData){
        //here something 
        lCurrentEnrollee.AudibleToneFlag = aData.AudibleToneFlag;
        setDataItem(lCurrentEnrollee.Id, 'Enrollees', lCurrentEnrollee);
        AssignGlobalIds(gEnrolleeIds, getCacheItem('Enrollees'), 'Id'); // this new line fixes ticket 980
        mActivityNotification.addNotification('Audible Tone command sent successfully.');
        ClosePopup();
    }, Sad);
}
function uGetAudibleToneWhenLowBattery_PopupOnClick(){
    var lCurrentEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
    var lCurrentAssignments =  gCurrentDeviceAssignment[mEnrolleesData.OffenderCurrentId],
        lAssignment;
    for (var lKey in lCurrentAssignments) {
        if (lCurrentAssignments.hasOwnProperty(lKey)) {
            lAssignment = lCurrentAssignments[lKey];
        }
    }
    var lButtonBar = GenerateButtonCommandBar(),
        aFlag = lCurrentEnrollee.AudibleToneFlag?0:1,
        html = lAssignment.AudibleToneFlag?'to vibrate':'make an audible tone';
        
    GenerateButton(localizeWrapper('cYes'), 'Yes', 'WriteAudibleTone('+mEnrolleesData.OffenderCurrentId+','+lAssignment.Id+','+aFlag+');').appendTo(lButtonBar);
    GenerateButton(localizeWrapper('cNo'), 'Close', function(){
        $('#uAudibleToneWhenLowBattery').attr('checked',!!lCurrentEnrollee.AudibleToneFlag);
        ClosePopup();
    }).appendTo(lButtonBar);
    DisplayPopup('Confirmation','<p>Do you want the device '+html+' when "Low Battery"?</p>', lButtonBar, false);    
}

function checkAddOnPerOrganization() {
    "use strict";
    var lReturn = false,
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lDevices,
        lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('OrganizationId', lEnrollee.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ProductId', 111, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lDevices = query(getDataItems('Devices'), lBuilder.RootExpression);

    if (ObjectLength(lDevices) > 0)
        lReturn = true;

    return lReturn;
}

function addAbsenceWithDeviceSave_OnClick(){
  if($('#uDeviceAssignmentsWizardStation247ScheduleAddAbsencesEdit').is(':checked')){
    $('#uDeviceAssignmentsWizardStation247ScheduleEdit').prop('checked',true);
  }
}

function checkDevice247_OnClick(){
  if(!$('#uDeviceAssignmentsWizardStation247ScheduleEdit').is(':checked')){
    $('#uDeviceAssignmentsWizardStation247ScheduleAddAbsencesEdit').prop('checked',false);
  }
}


function getEnrolleeCategoriesData(){
    var lSort = new SortExpression();
    lSort.addAscendingColumn('Description');
    return lSort.sort(getDataItems('SexOffense'));
}

function getEnrolleeClassificationsData(){
    var lSort = new SortExpression();
    lSort.addAscendingColumn('Description');
    return lSort.sort(getDataItems('MetaEnrolleeCategory'));
}